"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const designTokenVariables = {
  ':root': {
    '--st-dt-text-size-50': '0.75rem',
    '--st-dt-text-size-100': '0.875rem',
    '--st-dt-text-size-200': '1rem',
    '--st-dt-text-size-300': '1.125rem',
    '--st-dt-text-size-400': '1.25rem',
    '--st-dt-text-size-500': '1.375rem',
    '--st-dt-text-size-600': '1.5rem',
    '--st-dt-text-size-700': '1.75rem',
    '--st-dt-text-size-800': '2rem',
    '--st-dt-text-size-900': '2.5rem',
    '--st-dt-text-style-italic': 'italic',
    '--st-dt-text-family-default': 'Amazon Ember',
    '--st-dt-text-family-modernDisplay': 'Ember Modern Display Standard',
    '--st-dt-text-family-modernText': 'Amazon Ember',
    '--st-dt-text-lineHeight-50': '1.125rem',
    '--st-dt-text-lineHeight-100': '1.3125rem',
    '--st-dt-text-lineHeight-150': '1.4375rem',
    '--st-dt-text-lineHeight-200': '1.5rem',
    '--st-dt-text-lineHeight-250': '1.625rem',
    '--st-dt-text-lineHeight-300': '1.6875rem',
    '--st-dt-text-lineHeight-400': '1.8125rem',
    '--st-dt-text-lineHeight-500': '1.9375rem',
    '--st-dt-text-lineHeight-600': '2.25rem',
    '--st-dt-text-lineHeight-700': '2.625rem',
    '--st-dt-text-lineHeight-800': '3.25rem',
    '--st-dt-text-display-size-breakpoint-xl': 'var(--st-dt-text-size-900)',
    '--st-dt-text-display-size-breakpoint-lg': 'var(--st-dt-text-size-900)',
    '--st-dt-text-display-size-breakpoint-md': 'var(--st-dt-text-size-800)',
    '--st-dt-text-display-size-breakpoint-sm': 'var(--st-dt-text-size-800)',
    '--st-dt-text-display-weight-breakpoint-xl': 'var(--st-dt-text-weight-bold)',
    '--st-dt-text-display-weight-breakpoint-lg': 'var(--st-dt-text-weight-bold)',
    '--st-dt-text-display-weight-breakpoint-md': 'var(--st-dt-text-weight-bold)',
    '--st-dt-text-display-weight-breakpoint-sm': 'var(--st-dt-text-weight-bold)',
    '--st-dt-text-display-lineHeight-breakpoint-xl': 'var(--st-dt-text-lineHeight-800)',
    '--st-dt-text-display-lineHeight-breakpoint-lg': 'var(--st-dt-text-lineHeight-800)',
    '--st-dt-text-display-lineHeight-breakpoint-md': 'var(--st-dt-text-lineHeight-700)',
    '--st-dt-text-display-lineHeight-breakpoint-sm': 'var(--st-dt-text-lineHeight-700)',
    '--st-dt-text-display-family-breakpoint-xl': 'var(--st-dt-text-family-default)',
    '--st-dt-text-display-family-breakpoint-lg': 'var(--st-dt-text-family-default)',
    '--st-dt-text-display-family-breakpoint-md': 'var(--st-dt-text-family-default)',
    '--st-dt-text-display-family-breakpoint-sm': 'var(--st-dt-text-family-default)',
    '--st-dt-text-weight-regular': 400,
    '--st-dt-text-weight-medium': 500,
    '--st-dt-text-weight-bold': 700,
    '--st-dt-text-heading-xl-size-breakpoint-xl': 'var(--st-dt-text-size-800)',
    '--st-dt-text-heading-xl-size-breakpoint-lg': 'var(--st-dt-text-size-800)',
    '--st-dt-text-heading-xl-size-breakpoint-md': 'var(--st-dt-text-size-700)',
    '--st-dt-text-heading-xl-size-breakpoint-sm': 'var(--st-dt-text-size-700)',
    '--st-dt-text-heading-xl-weight-breakpoint-xl': 'var(--st-dt-text-weight-bold)',
    '--st-dt-text-heading-xl-weight-breakpoint-lg': 'var(--st-dt-text-weight-bold)',
    '--st-dt-text-heading-xl-weight-breakpoint-md': 'var(--st-dt-text-weight-bold)',
    '--st-dt-text-heading-xl-weight-breakpoint-sm': 'var(--st-dt-text-weight-bold)',
    '--st-dt-text-heading-xl-lineHeight-breakpoint-xl': 'var(--st-dt-text-lineHeight-700)',
    '--st-dt-text-heading-xl-lineHeight-breakpoint-lg': 'var(--st-dt-text-lineHeight-700)',
    '--st-dt-text-heading-xl-lineHeight-breakpoint-md': 'var(--st-dt-text-lineHeight-600)',
    '--st-dt-text-heading-xl-lineHeight-breakpoint-sm': 'var(--st-dt-text-lineHeight-600)',
    '--st-dt-text-heading-xl-family-breakpoint-xl': 'var(--st-dt-text-family-default)',
    '--st-dt-text-heading-xl-family-breakpoint-lg': 'var(--st-dt-text-family-default)',
    '--st-dt-text-heading-xl-family-breakpoint-md': 'var(--st-dt-text-family-default)',
    '--st-dt-text-heading-xl-family-breakpoint-sm': 'var(--st-dt-text-family-default)',
    '--st-dt-text-heading-lg-size-breakpoint-xl': 'var(--st-dt-text-size-600)',
    '--st-dt-text-heading-lg-size-breakpoint-lg': 'var(--st-dt-text-size-600)',
    '--st-dt-text-heading-lg-size-breakpoint-md': 'var(--st-dt-text-size-500)',
    '--st-dt-text-heading-lg-size-breakpoint-sm': 'var(--st-dt-text-size-500)',
    '--st-dt-text-heading-lg-weight-breakpoint-xl': 'var(--st-dt-text-weight-bold)',
    '--st-dt-text-heading-lg-weight-breakpoint-lg': 'var(--st-dt-text-weight-bold)',
    '--st-dt-text-heading-lg-weight-breakpoint-md': 'var(--st-dt-text-weight-bold)',
    '--st-dt-text-heading-lg-weight-breakpoint-sm': 'var(--st-dt-text-weight-bold)',
    '--st-dt-text-heading-lg-lineHeight-breakpoint-xl': 'var(--st-dt-text-lineHeight-500)',
    '--st-dt-text-heading-lg-lineHeight-breakpoint-lg': 'var(--st-dt-text-lineHeight-500)',
    '--st-dt-text-heading-lg-lineHeight-breakpoint-md': 'var(--st-dt-text-lineHeight-400)',
    '--st-dt-text-heading-lg-lineHeight-breakpoint-sm': 'var(--st-dt-text-lineHeight-400)',
    '--st-dt-text-heading-lg-family-breakpoint-xl': 'var(--st-dt-text-family-default)',
    '--st-dt-text-heading-lg-family-breakpoint-lg': 'var(--st-dt-text-family-default)',
    '--st-dt-text-heading-lg-family-breakpoint-md': 'var(--st-dt-text-family-default)',
    '--st-dt-text-heading-lg-family-breakpoint-sm': 'var(--st-dt-text-family-default)',
    '--st-dt-text-heading-md-size-breakpoint-xl': 'var(--st-dt-text-size-400)',
    '--st-dt-text-heading-md-size-breakpoint-lg': 'var(--st-dt-text-size-400)',
    '--st-dt-text-heading-md-size-breakpoint-md': 'var(--st-dt-text-size-300)',
    '--st-dt-text-heading-md-size-breakpoint-sm': 'var(--st-dt-text-size-300)',
    '--st-dt-text-heading-md-weight-breakpoint-xl': 'var(--st-dt-text-weight-bold)',
    '--st-dt-text-heading-md-weight-breakpoint-lg': 'var(--st-dt-text-weight-bold)',
    '--st-dt-text-heading-md-weight-breakpoint-md': 'var(--st-dt-text-weight-bold)',
    '--st-dt-text-heading-md-weight-breakpoint-sm': 'var(--st-dt-text-weight-bold)',
    '--st-dt-text-heading-md-lineHeight-breakpoint-xl': 'var(--st-dt-text-lineHeight-250)',
    '--st-dt-text-heading-md-lineHeight-breakpoint-lg': 'var(--st-dt-text-lineHeight-250)',
    '--st-dt-text-heading-md-lineHeight-breakpoint-md': 'var(--st-dt-text-lineHeight-150)',
    '--st-dt-text-heading-md-lineHeight-breakpoint-sm': 'var(--st-dt-text-lineHeight-150)',
    '--st-dt-text-heading-md-family-breakpoint-xl': 'var(--st-dt-text-family-default)',
    '--st-dt-text-heading-md-family-breakpoint-lg': 'var(--st-dt-text-family-default)',
    '--st-dt-text-heading-md-family-breakpoint-md': 'var(--st-dt-text-family-default)',
    '--st-dt-text-heading-md-family-breakpoint-sm': 'var(--st-dt-text-family-default)',
    '--st-dt-text-heading-sm-size-breakpoint-xl': 'var(--st-dt-text-size-200)',
    '--st-dt-text-heading-sm-size-breakpoint-lg': 'var(--st-dt-text-size-200)',
    '--st-dt-text-heading-sm-size-breakpoint-md': 'var(--st-dt-text-size-200)',
    '--st-dt-text-heading-sm-size-breakpoint-sm': 'var(--st-dt-text-size-200)',
    '--st-dt-text-heading-sm-weight-breakpoint-xl': 'var(--st-dt-text-weight-bold)',
    '--st-dt-text-heading-sm-weight-breakpoint-lg': 'var(--st-dt-text-weight-bold)',
    '--st-dt-text-heading-sm-weight-breakpoint-md': 'var(--st-dt-text-weight-bold)',
    '--st-dt-text-heading-sm-weight-breakpoint-sm': 'var(--st-dt-text-weight-bold)',
    '--st-dt-text-heading-sm-lineHeight-breakpoint-xl': 'var(--st-dt-text-lineHeight-100)',
    '--st-dt-text-heading-sm-lineHeight-breakpoint-lg': 'var(--st-dt-text-lineHeight-100)',
    '--st-dt-text-heading-sm-lineHeight-breakpoint-md': 'var(--st-dt-text-lineHeight-100)',
    '--st-dt-text-heading-sm-lineHeight-breakpoint-sm': 'var(--st-dt-text-lineHeight-100)',
    '--st-dt-text-heading-sm-family-breakpoint-xl': 'var(--st-dt-text-family-default)',
    '--st-dt-text-heading-sm-family-breakpoint-lg': 'var(--st-dt-text-family-default)',
    '--st-dt-text-heading-sm-family-breakpoint-md': 'var(--st-dt-text-family-default)',
    '--st-dt-text-heading-sm-family-breakpoint-sm': 'var(--st-dt-text-family-default)',
    '--st-dt-text-heading-xs-size-breakpoint-xl': 'var(--st-dt-text-size-100)',
    '--st-dt-text-heading-xs-size-breakpoint-lg': 'var(--st-dt-text-size-100)',
    '--st-dt-text-heading-xs-size-breakpoint-md': 'var(--st-dt-text-size-100)',
    '--st-dt-text-heading-xs-size-breakpoint-sm': 'var(--st-dt-text-size-100)',
    '--st-dt-text-heading-xs-weight-breakpoint-xl': 'var(--st-dt-text-weight-bold)',
    '--st-dt-text-heading-xs-weight-breakpoint-lg': 'var(--st-dt-text-weight-bold)',
    '--st-dt-text-heading-xs-weight-breakpoint-md': 'var(--st-dt-text-weight-bold)',
    '--st-dt-text-heading-xs-weight-breakpoint-sm': 'var(--st-dt-text-weight-bold)',
    '--st-dt-text-heading-xs-lineHeight-breakpoint-xl': 'var(--st-dt-text-lineHeight-50)',
    '--st-dt-text-heading-xs-lineHeight-breakpoint-lg': 'var(--st-dt-text-lineHeight-50)',
    '--st-dt-text-heading-xs-lineHeight-breakpoint-md': 'var(--st-dt-text-lineHeight-50)',
    '--st-dt-text-heading-xs-lineHeight-breakpoint-sm': 'var(--st-dt-text-lineHeight-50)',
    '--st-dt-text-heading-xs-family-breakpoint-xl': 'var(--st-dt-text-family-default)',
    '--st-dt-text-heading-xs-family-breakpoint-lg': 'var(--st-dt-text-family-default)',
    '--st-dt-text-heading-xs-family-breakpoint-md': 'var(--st-dt-text-family-default)',
    '--st-dt-text-heading-xs-family-breakpoint-sm': 'var(--st-dt-text-family-default)',
    '--st-dt-text-heading-xxs-size-breakpoint-xl': 'var(--st-dt-text-size-100)',
    '--st-dt-text-heading-xxs-size-breakpoint-lg': 'var(--st-dt-text-size-100)',
    '--st-dt-text-heading-xxs-size-breakpoint-md': 'var(--st-dt-text-size-100)',
    '--st-dt-text-heading-xxs-size-breakpoint-sm': 'var(--st-dt-text-size-100)',
    '--st-dt-text-heading-xxs-weight-breakpoint-xl': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-heading-xxs-weight-breakpoint-lg': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-heading-xxs-weight-breakpoint-md': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-heading-xxs-weight-breakpoint-sm': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-heading-xxs-lineHeight-breakpoint-xl': 'var(--st-dt-text-lineHeight-50)',
    '--st-dt-text-heading-xxs-lineHeight-breakpoint-lg': 'var(--st-dt-text-lineHeight-50)',
    '--st-dt-text-heading-xxs-lineHeight-breakpoint-md': 'var(--st-dt-text-lineHeight-50)',
    '--st-dt-text-heading-xxs-lineHeight-breakpoint-sm': 'var(--st-dt-text-lineHeight-50)',
    '--st-dt-text-heading-xxs-family-breakpoint-xl': 'var(--st-dt-text-family-default)',
    '--st-dt-text-heading-xxs-family-breakpoint-lg': 'var(--st-dt-text-family-default)',
    '--st-dt-text-heading-xxs-family-breakpoint-md': 'var(--st-dt-text-family-default)',
    '--st-dt-text-heading-xxs-family-breakpoint-sm': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-md-size-breakpoint-xl': 'var(--st-dt-text-size-200)',
    '--st-dt-text-body-md-size-breakpoint-lg': 'var(--st-dt-text-size-200)',
    '--st-dt-text-body-md-size-breakpoint-md': 'var(--st-dt-text-size-200)',
    '--st-dt-text-body-md-size-breakpoint-sm': 'var(--st-dt-text-size-200)',
    '--st-dt-text-body-md-weight-breakpoint-xl': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-body-md-weight-breakpoint-lg': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-body-md-weight-breakpoint-md': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-body-md-weight-breakpoint-sm': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-body-md-lineHeight-breakpoint-xl': 'var(--st-dt-text-lineHeight-200)',
    '--st-dt-text-body-md-lineHeight-breakpoint-lg': 'var(--st-dt-text-lineHeight-200)',
    '--st-dt-text-body-md-lineHeight-breakpoint-md': 'var(--st-dt-text-lineHeight-200)',
    '--st-dt-text-body-md-lineHeight-breakpoint-sm': 'var(--st-dt-text-lineHeight-200)',
    '--st-dt-text-body-md-family-breakpoint-xl': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-md-family-breakpoint-lg': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-md-family-breakpoint-md': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-md-family-breakpoint-sm': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-sm-size-breakpoint-xl': 'var(--st-dt-text-size-100)',
    '--st-dt-text-body-sm-size-breakpoint-lg': 'var(--st-dt-text-size-100)',
    '--st-dt-text-body-sm-size-breakpoint-md': 'var(--st-dt-text-size-100)',
    '--st-dt-text-body-sm-size-breakpoint-sm': 'var(--st-dt-text-size-100)',
    '--st-dt-text-body-sm-weight-breakpoint-xl': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-body-sm-weight-breakpoint-lg': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-body-sm-weight-breakpoint-md': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-body-sm-weight-breakpoint-sm': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-body-sm-lineHeight-breakpoint-xl': 'var(--st-dt-text-lineHeight-100)',
    '--st-dt-text-body-sm-lineHeight-breakpoint-lg': 'var(--st-dt-text-lineHeight-100)',
    '--st-dt-text-body-sm-lineHeight-breakpoint-md': 'var(--st-dt-text-lineHeight-100)',
    '--st-dt-text-body-sm-lineHeight-breakpoint-sm': 'var(--st-dt-text-lineHeight-100)',
    '--st-dt-text-body-sm-family-breakpoint-xl': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-sm-family-breakpoint-lg': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-sm-family-breakpoint-md': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-sm-family-breakpoint-sm': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-hint-size-breakpoint-xl': 'var(--st-dt-text-size-200)',
    '--st-dt-text-body-hint-size-breakpoint-lg': 'var(--st-dt-text-size-200)',
    '--st-dt-text-body-hint-size-breakpoint-md': 'var(--st-dt-text-size-200)',
    '--st-dt-text-body-hint-size-breakpoint-sm': 'var(--st-dt-text-size-200)',
    '--st-dt-text-body-hint-weight-breakpoint-xl': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-body-hint-weight-breakpoint-lg': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-body-hint-weight-breakpoint-md': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-body-hint-weight-breakpoint-sm': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-body-hint-lineHeight-breakpoint-xl': 'var(--st-dt-text-lineHeight-200)',
    '--st-dt-text-body-hint-lineHeight-breakpoint-lg': 'var(--st-dt-text-lineHeight-200)',
    '--st-dt-text-body-hint-lineHeight-breakpoint-md': 'var(--st-dt-text-lineHeight-200)',
    '--st-dt-text-body-hint-lineHeight-breakpoint-sm': 'var(--st-dt-text-lineHeight-200)',
    '--st-dt-text-body-hint-style-breakpoint-xl': 'var(--st-dt-text-style-italic)',
    '--st-dt-text-body-hint-style-breakpoint-lg': 'var(--st-dt-text-style-italic)',
    '--st-dt-text-body-hint-style-breakpoint-md': 'var(--st-dt-text-style-italic)',
    '--st-dt-text-body-hint-style-breakpoint-sm': 'var(--st-dt-text-style-italic)',
    '--st-dt-text-body-hint-family-breakpoint-xl': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-hint-family-breakpoint-lg': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-hint-family-breakpoint-md': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-hint-family-breakpoint-sm': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-lg-size-breakpoint-xl': 'var(--st-dt-text-size-300)',
    '--st-dt-text-body-lg-size-breakpoint-lg': 'var(--st-dt-text-size-300)',
    '--st-dt-text-body-lg-size-breakpoint-md': 'var(--st-dt-text-size-300)',
    '--st-dt-text-body-lg-size-breakpoint-sm': 'var(--st-dt-text-size-300)',
    '--st-dt-text-body-lg-weight-breakpoint-xl': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-body-lg-weight-breakpoint-lg': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-body-lg-weight-breakpoint-md': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-body-lg-weight-breakpoint-sm': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-body-lg-lineHeight-breakpoint-xl': 'var(--st-dt-text-lineHeight-300)',
    '--st-dt-text-body-lg-lineHeight-breakpoint-lg': 'var(--st-dt-text-lineHeight-300)',
    '--st-dt-text-body-lg-lineHeight-breakpoint-md': 'var(--st-dt-text-lineHeight-300)',
    '--st-dt-text-body-lg-lineHeight-breakpoint-sm': 'var(--st-dt-text-lineHeight-300)',
    '--st-dt-text-body-lg-family-breakpoint-xl': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-lg-family-breakpoint-lg': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-lg-family-breakpoint-md': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-lg-family-breakpoint-sm': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-sm-interactive-size-breakpoint-xl': 'var(--st-dt-text-size-100)',
    '--st-dt-text-body-sm-interactive-size-breakpoint-lg': 'var(--st-dt-text-size-100)',
    '--st-dt-text-body-sm-interactive-size-breakpoint-md': 'var(--st-dt-text-size-100)',
    '--st-dt-text-body-sm-interactive-size-breakpoint-sm': 'var(--st-dt-text-size-100)',
    '--st-dt-text-body-sm-interactive-weight-breakpoint-xl': 'var(--st-dt-text-weight-medium)',
    '--st-dt-text-body-sm-interactive-weight-breakpoint-lg': 'var(--st-dt-text-weight-medium)',
    '--st-dt-text-body-sm-interactive-weight-breakpoint-md': 'var(--st-dt-text-weight-medium)',
    '--st-dt-text-body-sm-interactive-weight-breakpoint-sm': 'var(--st-dt-text-weight-medium)',
    '--st-dt-text-body-sm-interactive-lineHeight-breakpoint-xl': 'var(--st-dt-text-lineHeight-100)',
    '--st-dt-text-body-sm-interactive-lineHeight-breakpoint-lg': 'var(--st-dt-text-lineHeight-100)',
    '--st-dt-text-body-sm-interactive-lineHeight-breakpoint-md': 'var(--st-dt-text-lineHeight-100)',
    '--st-dt-text-body-sm-interactive-lineHeight-breakpoint-sm': 'var(--st-dt-text-lineHeight-100)',
    '--st-dt-text-body-sm-interactive-family-breakpoint-xl': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-sm-interactive-family-breakpoint-lg': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-sm-interactive-family-breakpoint-md': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-sm-interactive-family-breakpoint-sm': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-md-interactive-size-breakpoint-xl': 'var(--st-dt-text-size-200)',
    '--st-dt-text-body-md-interactive-size-breakpoint-lg': 'var(--st-dt-text-size-200)',
    '--st-dt-text-body-md-interactive-size-breakpoint-md': 'var(--st-dt-text-size-200)',
    '--st-dt-text-body-md-interactive-size-breakpoint-sm': 'var(--st-dt-text-size-200)',
    '--st-dt-text-body-md-interactive-weight-breakpoint-xl': 'var(--st-dt-text-weight-medium)',
    '--st-dt-text-body-md-interactive-weight-breakpoint-lg': 'var(--st-dt-text-weight-medium)',
    '--st-dt-text-body-md-interactive-weight-breakpoint-md': 'var(--st-dt-text-weight-medium)',
    '--st-dt-text-body-md-interactive-weight-breakpoint-sm': 'var(--st-dt-text-weight-medium)',
    '--st-dt-text-body-md-interactive-lineHeight-breakpoint-xl': 'var(--st-dt-text-lineHeight-200)',
    '--st-dt-text-body-md-interactive-lineHeight-breakpoint-lg': 'var(--st-dt-text-lineHeight-200)',
    '--st-dt-text-body-md-interactive-lineHeight-breakpoint-md': 'var(--st-dt-text-lineHeight-200)',
    '--st-dt-text-body-md-interactive-lineHeight-breakpoint-sm': 'var(--st-dt-text-lineHeight-200)',
    '--st-dt-text-body-md-interactive-family-breakpoint-xl': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-md-interactive-family-breakpoint-lg': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-md-interactive-family-breakpoint-md': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-md-interactive-family-breakpoint-sm': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-lg-interactive-size-breakpoint-xl': 'var(--st-dt-text-size-300)',
    '--st-dt-text-body-lg-interactive-size-breakpoint-lg': 'var(--st-dt-text-size-300)',
    '--st-dt-text-body-lg-interactive-size-breakpoint-md': 'var(--st-dt-text-size-300)',
    '--st-dt-text-body-lg-interactive-size-breakpoint-sm': 'var(--st-dt-text-size-300)',
    '--st-dt-text-body-lg-interactive-weight-breakpoint-xl': 'var(--st-dt-text-weight-medium)',
    '--st-dt-text-body-lg-interactive-weight-breakpoint-lg': 'var(--st-dt-text-weight-medium)',
    '--st-dt-text-body-lg-interactive-weight-breakpoint-md': 'var(--st-dt-text-weight-medium)',
    '--st-dt-text-body-lg-interactive-weight-breakpoint-sm': 'var(--st-dt-text-weight-medium)',
    '--st-dt-text-body-lg-interactive-lineHeight-breakpoint-xl': 'var(--st-dt-text-lineHeight-300)',
    '--st-dt-text-body-lg-interactive-lineHeight-breakpoint-lg': 'var(--st-dt-text-lineHeight-300)',
    '--st-dt-text-body-lg-interactive-lineHeight-breakpoint-md': 'var(--st-dt-text-lineHeight-300)',
    '--st-dt-text-body-lg-interactive-lineHeight-breakpoint-sm': 'var(--st-dt-text-lineHeight-300)',
    '--st-dt-text-body-lg-interactive-family-breakpoint-xl': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-lg-interactive-family-breakpoint-lg': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-lg-interactive-family-breakpoint-md': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-lg-interactive-family-breakpoint-sm': 'var(--st-dt-text-family-default)',
    '--st-dt-text-label-md-size-breakpoint-xl': 'var(--st-dt-text-size-200)',
    '--st-dt-text-label-md-size-breakpoint-lg': 'var(--st-dt-text-size-200)',
    '--st-dt-text-label-md-size-breakpoint-md': 'var(--st-dt-text-size-200)',
    '--st-dt-text-label-md-size-breakpoint-sm': 'var(--st-dt-text-size-200)',
    '--st-dt-text-label-md-weight-breakpoint-xl': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-label-md-weight-breakpoint-lg': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-label-md-weight-breakpoint-md': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-label-md-weight-breakpoint-sm': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-label-md-lineHeight-breakpoint-xl': 'var(--st-dt-text-lineHeight-200)',
    '--st-dt-text-label-md-lineHeight-breakpoint-lg': 'var(--st-dt-text-lineHeight-200)',
    '--st-dt-text-label-md-lineHeight-breakpoint-md': 'var(--st-dt-text-lineHeight-200)',
    '--st-dt-text-label-md-lineHeight-breakpoint-sm': 'var(--st-dt-text-lineHeight-200)',
    '--st-dt-text-label-md-family-breakpoint-xl': 'var(--st-dt-text-family-default)',
    '--st-dt-text-label-md-family-breakpoint-lg': 'var(--st-dt-text-family-default)',
    '--st-dt-text-label-md-family-breakpoint-md': 'var(--st-dt-text-family-default)',
    '--st-dt-text-label-md-family-breakpoint-sm': 'var(--st-dt-text-family-default)',
    '--st-dt-text-label-sm-size-breakpoint-xl': 'var(--st-dt-text-size-100)',
    '--st-dt-text-label-sm-size-breakpoint-lg': 'var(--st-dt-text-size-100)',
    '--st-dt-text-label-sm-size-breakpoint-md': 'var(--st-dt-text-size-100)',
    '--st-dt-text-label-sm-size-breakpoint-sm': 'var(--st-dt-text-size-100)',
    '--st-dt-text-label-sm-weight-breakpoint-xl': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-label-sm-weight-breakpoint-lg': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-label-sm-weight-breakpoint-md': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-label-sm-weight-breakpoint-sm': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-label-sm-lineHeight-breakpoint-xl': 'var(--st-dt-text-lineHeight-100)',
    '--st-dt-text-label-sm-lineHeight-breakpoint-lg': 'var(--st-dt-text-lineHeight-100)',
    '--st-dt-text-label-sm-lineHeight-breakpoint-md': 'var(--st-dt-text-lineHeight-100)',
    '--st-dt-text-label-sm-lineHeight-breakpoint-sm': 'var(--st-dt-text-lineHeight-100)',
    '--st-dt-text-label-sm-family-breakpoint-xl': 'var(--st-dt-text-family-default)',
    '--st-dt-text-label-sm-family-breakpoint-lg': 'var(--st-dt-text-family-default)',
    '--st-dt-text-label-sm-family-breakpoint-md': 'var(--st-dt-text-family-default)',
    '--st-dt-text-label-sm-family-breakpoint-sm': 'var(--st-dt-text-family-default)',
    '--st-dt-text-label-xs-size-breakpoint-xl': 'var(--st-dt-text-size-50)',
    '--st-dt-text-label-xs-size-breakpoint-lg': 'var(--st-dt-text-size-50)',
    '--st-dt-text-label-xs-size-breakpoint-md': 'var(--st-dt-text-size-50)',
    '--st-dt-text-label-xs-size-breakpoint-sm': 'var(--st-dt-text-size-50)',
    '--st-dt-text-label-xs-weight-breakpoint-xl': 'var(--st-dt-text-weight-medium)',
    '--st-dt-text-label-xs-weight-breakpoint-lg': 'var(--st-dt-text-weight-medium)',
    '--st-dt-text-label-xs-weight-breakpoint-md': 'var(--st-dt-text-weight-medium)',
    '--st-dt-text-label-xs-weight-breakpoint-sm': 'var(--st-dt-text-weight-medium)',
    '--st-dt-text-label-xs-lineHeight-breakpoint-xl': 'var(--st-dt-text-lineHeight-50)',
    '--st-dt-text-label-xs-lineHeight-breakpoint-lg': 'var(--st-dt-text-lineHeight-50)',
    '--st-dt-text-label-xs-lineHeight-breakpoint-md': 'var(--st-dt-text-lineHeight-50)',
    '--st-dt-text-label-xs-lineHeight-breakpoint-sm': 'var(--st-dt-text-lineHeight-50)',
    '--st-dt-text-label-xs-family-breakpoint-xl': 'var(--st-dt-text-family-default)',
    '--st-dt-text-label-xs-family-breakpoint-lg': 'var(--st-dt-text-family-default)',
    '--st-dt-text-label-xs-family-breakpoint-md': 'var(--st-dt-text-family-default)',
    '--st-dt-text-label-xs-family-breakpoint-sm': 'var(--st-dt-text-family-default)',
    '--st-dt-color-neutral-10': '#e8eaee',
    '--st-dt-color-neutral-20': '#d1d5da',
    '--st-dt-color-neutral-30': '#b9c0c8',
    '--st-dt-color-neutral-40': '#a2abb5',
    '--st-dt-color-neutral-50': '#8b96a3',
    '--st-dt-color-neutral-60': '#737e8b',
    '--st-dt-color-neutral-70': '#56616c',
    '--st-dt-color-neutral-80': '#394451',
    '--st-dt-color-neutral-90': '#232f3e',
    '--st-dt-color-neutral-100': '#161e2d',
    '--st-dt-color-neutral-00': '#ffffff',
    '--st-dt-color-neutral-05': '#f1f4f7',
    '--st-dt-color-blue-10': '#d7ebfb',
    '--st-dt-color-blue-20': '#afd7f7',
    '--st-dt-color-blue-30': '#87c2f4',
    '--st-dt-color-blue-40': '#5faef0',
    '--st-dt-color-blue-50': '#379aec',
    '--st-dt-color-blue-60': '#0077d9',
    '--st-dt-color-blue-70': '#1768c9',
    '--st-dt-color-blue-80': '#1659a9',
    '--st-dt-color-blue-90': '#123b74',
    '--st-dt-color-blue-05': '#ebf5fd',
    '--st-dt-color-green-10': '#d7f3ed',
    '--st-dt-color-green-20': '#afe7db',
    '--st-dt-color-green-30': '#86dac9',
    '--st-dt-color-green-40': '#5eceb7',
    '--st-dt-color-green-50': '#00a890',
    '--st-dt-color-green-60': '#008574',
    '--st-dt-color-green-70': '#23756b',
    '--st-dt-color-green-80': '#195f57',
    '--st-dt-color-green-90': '#104643',
    '--st-dt-color-green-05': '#ebf9f6',
    '--st-dt-color-red-10': '#fde1df',
    '--st-dt-color-red-20': '#fbc3bf',
    '--st-dt-color-red-30': '#f8a49e',
    '--st-dt-color-red-40': '#f6867e',
    '--st-dt-color-red-50': '#f4685e',
    '--st-dt-color-red-60': '#da3733',
    '--st-dt-color-red-70': '#bb2929',
    '--st-dt-color-red-80': '#9a1818',
    '--st-dt-color-red-90': '#710400',
    '--st-dt-color-red-05': '#fef0ef',
    '--st-dt-color-yellow-10': '#fff3cc',
    '--st-dt-color-yellow-20': '#ffe799',
    '--st-dt-color-yellow-30': '#ffdc66',
    '--st-dt-color-yellow-40': '#ffd033',
    '--st-dt-color-yellow-50': '#ffc400',
    '--st-dt-color-yellow-60': '#ca8700',
    '--st-dt-color-yellow-70': '#b27400',
    '--st-dt-color-yellow-80': '#8e5d00',
    '--st-dt-color-yellow-90': '#684500',
    '--st-dt-color-yellow-05': '#fff9e6',
    '--st-dt-color-pink-10': '#f3deeb',
    '--st-dt-color-pink-20': '#e8bdd7',
    '--st-dt-color-pink-30': '#dd9cc4',
    '--st-dt-color-pink-40': '#d27bb0',
    '--st-dt-color-pink-50': '#cf6ba0',
    '--st-dt-color-pink-60': '#ba3385',
    '--st-dt-color-pink-70': '#a90067',
    '--st-dt-color-pink-80': '#8b065b',
    '--st-dt-color-pink-90': '#6e0c4f',
    '--st-dt-color-pink-05': '#faf2f7',
    '--st-dt-color-purple-10': '#f2e4fb',
    '--st-dt-color-purple-20': '#e5c8f7',
    '--st-dt-color-purple-30': '#d9adf2',
    '--st-dt-color-purple-40': '#cc91ee',
    '--st-dt-color-purple-50': '#bf76ea',
    '--st-dt-color-purple-60': '#a249e0',
    '--st-dt-color-purple-70': '#8b46c6',
    '--st-dt-color-purple-80': '#7037a3',
    '--st-dt-color-purple-90': '#51267f',
    '--st-dt-color-purple-05': '#f9f1fd',
    '--st-dt-color-surface-bg-default': 'var(--st-dt-color-neutral-00)',
    '--st-dt-color-surface-bg-muted': 'var(--st-dt-color-neutral-05)',
    '--st-dt-color-surface-overlay': 'var(--st-dt-color-transparent-neutral90-alpha30)',
    '--st-dt-color-surface-dark-bg-static': 'var(--st-dt-color-neutral-90)',
    '--st-dt-color-surface-bg-raised': 'var(--st-dt-color-neutral-00)',
    '--st-dt-color-fill-neutral-primary': 'var(--st-dt-color-neutral-00)',
    '--st-dt-color-fill-neutral-muted': 'var(--st-dt-color-neutral-05)',
    '--st-dt-color-fill-neutral-secondary': 'var(--st-dt-color-neutral-10)',
    '--st-dt-color-fill-neutral-tertiary': 'var(--st-dt-color-neutral-20)',
    '--st-dt-color-fill-vibrant-gray': 'var(--st-dt-color-neutral-70)',
    '--st-dt-color-fill-vibrant-blue': 'var(--st-dt-color-blue-70)',
    '--st-dt-color-fill-vibrant-red': 'var(--st-dt-color-red-70)',
    '--st-dt-color-fill-vibrant-green': 'var(--st-dt-color-green-70)',
    '--st-dt-color-fill-vibrant-yellow': 'var(--st-dt-color-yellow-80)',
    '--st-dt-color-fill-vibrant-purple': 'var(--st-dt-color-purple-70)',
    '--st-dt-color-fill-vibrant-pink': 'var(--st-dt-color-pink-70)',
    '--st-dt-color-fill-muted-gray': 'var(--st-dt-color-neutral-10)',
    '--st-dt-color-fill-muted-blue': 'var(--st-dt-color-blue-10)',
    '--st-dt-color-fill-muted-red': 'var(--st-dt-color-red-10)',
    '--st-dt-color-fill-muted-green': 'var(--st-dt-color-green-10)',
    '--st-dt-color-fill-muted-yellow': 'var(--st-dt-color-yellow-10)',
    '--st-dt-color-fill-muted-pink': 'var(--st-dt-color-pink-10)',
    '--st-dt-color-fill-muted-purple': 'var(--st-dt-color-purple-10)',
    '--st-dt-color-text-primary': 'var(--st-dt-color-neutral-90)',
    '--st-dt-color-text-secondary': 'var(--st-dt-color-neutral-70)',
    '--st-dt-color-text-primary-inverted': 'var(--st-dt-color-neutral-05)',
    '--st-dt-color-text-secondary-inverted': 'var(--st-dt-color-neutral-20)',
    '--st-dt-color-text-disabled': 'var(--st-dt-color-neutral-40)',
    '--st-dt-color-text-accent': 'var(--st-dt-color-blue-70)',
    '--st-dt-color-icon-primary-default': 'var(--st-dt-color-neutral-90)',
    '--st-dt-color-icon-secondary': 'var(--st-dt-color-neutral-70)',
    '--st-dt-color-icon-primary-inverted-default': 'var(--st-dt-color-neutral-05)',
    '--st-dt-color-icon-secondary-inverted': 'var(--st-dt-color-neutral-20)',
    '--st-dt-color-icon-interactive-default': 'var(--st-dt-color-blue-70)',
    '--st-dt-color-icon-interactive-hover': 'var(--st-dt-color-blue-60)',
    '--st-dt-color-icon-interactive-pressed': 'var(--st-dt-color-blue-80)',
    '--st-dt-color-icon-interactive-disabled': 'var(--st-dt-color-blue-30)',
    '--st-dt-color-icon-critical-default': 'var(--st-dt-color-red-70)',
    '--st-dt-color-icon-critical-hover': 'var(--st-dt-color-red-60)',
    '--st-dt-color-icon-critical-pressed': 'var(--st-dt-color-red-80)',
    '--st-dt-color-icon-critical-disabled': 'var(--st-dt-color-red-30)',
    '--st-dt-color-icon-primary-hover': 'var(--st-dt-color-neutral-80)',
    '--st-dt-color-icon-primary-pressed': 'var(--st-dt-color-neutral-100)',
    '--st-dt-color-icon-primary-disabled': 'var(--st-dt-color-neutral-30)',
    '--st-dt-color-icon-primary-inverted-hover': 'var(--st-dt-color-neutral-10)',
    '--st-dt-color-icon-primary-inverted-pressed': 'var(--st-dt-color-neutral-00)',
    '--st-dt-color-icon-primary-inverted-disabled': 'var(--st-dt-color-neutral-30)',
    '--st-dt-color-link-primary-default': 'var(--st-dt-color-blue-70)',
    '--st-dt-color-link-primary-hover': 'var(--st-dt-color-blue-60)',
    '--st-dt-color-link-primary-pressed': 'var(--st-dt-color-blue-80)',
    '--st-dt-color-link-primary-disabled': 'var(--st-dt-color-blue-30)',
    '--st-dt-color-link-inverted-default': 'var(--st-dt-color-neutral-05)',
    '--st-dt-color-link-inverted-hover': 'var(--st-dt-color-neutral-10)',
    '--st-dt-color-link-inverted-pressed': 'var(--st-dt-color-neutral-00)',
    '--st-dt-color-link-inverted-disabled': 'var(--st-dt-color-neutral-30)',
    '--st-dt-color-link-neutral-default': 'var(--st-dt-color-neutral-90)',
    '--st-dt-color-link-neutral-hover': 'var(--st-dt-color-neutral-80)',
    '--st-dt-color-link-neutral-pressed': 'var(--st-dt-color-neutral-100)',
    '--st-dt-color-link-neutral-disabled': 'var(--st-dt-color-neutral-30)',
    '--st-dt-color-link-critical-default': 'var(--st-dt-color-red-70)',
    '--st-dt-color-link-critical-hover': 'var(--st-dt-color-red-60)',
    '--st-dt-color-link-critical-pressed': 'var(--st-dt-color-red-80)',
    '--st-dt-color-link-critical-disabled': 'var(--st-dt-color-red-30)',
    '--st-dt-color-border-primary': 'var(--st-dt-color-neutral-20)',
    '--st-dt-color-border-border-focus': 'var(--st-dt-color-blue-70)',
    '--st-dt-color-action-primary-bg-default': 'var(--st-dt-color-blue-70)',
    '--st-dt-color-action-primary-bg-hover': 'var(--st-dt-color-blue-60)',
    '--st-dt-color-action-primary-bg-pressed': 'var(--st-dt-color-blue-80)',
    '--st-dt-color-action-primary-bg-disabled': 'var(--st-dt-color-transparent-blue70-alpha30)',
    '--st-dt-color-action-primary-critical-bg-default': 'var(--st-dt-color-red-70)',
    '--st-dt-color-action-primary-critical-bg-hover': 'var(--st-dt-color-red-60)',
    '--st-dt-color-action-primary-critical-bg-pressed': 'var(--st-dt-color-red-80)',
    '--st-dt-color-action-primary-critical-bg-disabled': 'var(--st-dt-color-transparent-red70-alpha30)',
    '--st-dt-color-action-secondary-bg-default': 'var(--st-dt-color-neutral-00)',
    '--st-dt-color-action-secondary-bg-hover': 'var(--st-dt-color-blue-10)',
    '--st-dt-color-action-secondary-bg-pressed': 'var(--st-dt-color-blue-20)',
    '--st-dt-color-action-secondary-bg-disabled': 'var(--st-dt-color-neutral-05)',
    '--st-dt-color-action-secondary-border-default': 'var(--st-dt-color-blue-70)',
    '--st-dt-color-action-secondary-border-hover': 'var(--st-dt-color-blue-60)',
    '--st-dt-color-action-secondary-border-pressed': 'var(--st-dt-color-blue-80)',
    '--st-dt-color-action-secondary-border-disabled': 'var(--st-dt-color-blue-30)',
    '--st-dt-color-action-secondary-critical-bg-default': 'var(--st-dt-color-neutral-00)',
    '--st-dt-color-action-secondary-critical-bg-hover': 'var(--st-dt-color-red-10)',
    '--st-dt-color-action-secondary-critical-bg-pressed': 'var(--st-dt-color-red-20)',
    '--st-dt-color-action-secondary-critical-bg-disabled': 'var(--st-dt-color-neutral-05)',
    '--st-dt-color-action-tertiary-bg-hover': 'var(--st-dt-color-blue-10)',
    '--st-dt-color-action-tertiary-bg-pressed': 'var(--st-dt-color-blue-20)',
    '--st-dt-color-action-tertiary-critical-bg-hover': 'var(--st-dt-color-red-10)',
    '--st-dt-color-action-tertiary-critical-bg-pressed': 'var(--st-dt-color-red-20)',
    '--st-dt-color-action-utility-bg-default': 'var(--st-dt-color-neutral-00)',
    '--st-dt-color-action-utility-bg-hover': 'var(--st-dt-color-neutral-10)',
    '--st-dt-color-action-utility-bg-pressed': 'var(--st-dt-color-neutral-20)',
    '--st-dt-color-action-utility-selected-bg-default': 'var(--st-dt-color-neutral-90)',
    '--st-dt-color-action-utility-selected-bg-hover': 'var(--st-dt-color-neutral-80)',
    '--st-dt-color-action-utility-selected-bg-pressed': 'var(--st-dt-color-neutral-100)',
    '--st-dt-color-action-utility-selected-bg-disabled': 'var(--st-dt-color-neutral-40)',
    '--st-dt-color-action-utility-border': 'var(--st-dt-color-neutral-50)',
    '--st-dt-color-action-utility-bg-disabled': 'var(--st-dt-color-neutral-05)',
    '--st-dt-color-action-utility-selected-border': 'var(--st-dt-color-neutral-90)',
    '--st-dt-color-action-utility-adaptive-bg-hover': 'var(--st-dt-color-transparent-neutral90-alpha10)',
    '--st-dt-color-action-utility-adaptive-bg-pressed': 'var(--st-dt-color-transparent-neutral90-alpha20)',
    '--st-dt-color-input-bg-default': 'var(--st-dt-color-neutral-00)',
    '--st-dt-color-input-border-default': 'var(--st-dt-color-neutral-50)',
    '--st-dt-color-input-border-hover': 'var(--st-dt-color-blue-60)',
    '--st-dt-color-input-border-pressed': 'var(--st-dt-color-blue-80)',
    '--st-dt-color-input-border-disabled': 'var(--st-dt-color-neutral-20)',
    '--st-dt-color-input-bg-disabled': 'var(--st-dt-color-neutral-05)',
    '--st-dt-color-input-selected-bg-default': 'var(--st-dt-color-blue-70)',
    '--st-dt-color-input-selected-bg-hover': 'var(--st-dt-color-blue-60)',
    '--st-dt-color-input-selected-bg-pressed': 'var(--st-dt-color-blue-80)',
    '--st-dt-color-input-selected-bg-disabled': 'var(--st-dt-color-blue-30)',
    '--st-dt-color-input-selected-critical-bg-default': 'var(--st-dt-color-red-70)',
    '--st-dt-color-input-selected-critical-bg-hover': 'var(--st-dt-color-red-60)',
    '--st-dt-color-input-selected-critical-bg-pressed': 'var(--st-dt-color-red-80)',
    '--st-dt-color-input-selected-critical-bg-disabled': 'var(--st-dt-color-red-30)',
    '--st-dt-color-input-selected-border-default': 'var(--st-dt-color-blue-70)',
    '--st-dt-color-input-selected-border-disabled': 'var(--st-dt-color-blue-30)',
    '--st-dt-color-status-info-bg': 'var(--st-dt-color-blue-10)',
    '--st-dt-color-status-info-border': 'var(--st-dt-color-blue-70)',
    '--st-dt-color-status-info-icon': 'var(--st-dt-color-blue-70)',
    '--st-dt-color-status-success-bg': 'var(--st-dt-color-green-10)',
    '--st-dt-color-status-success-border-default': 'var(--st-dt-color-green-70)',
    '--st-dt-color-status-success-icon': 'var(--st-dt-color-green-70)',
    '--st-dt-color-status-warning-bg': 'var(--st-dt-color-yellow-10)',
    '--st-dt-color-status-warning-border-default': 'var(--st-dt-color-yellow-70)',
    '--st-dt-color-status-warning-icon': 'var(--st-dt-color-yellow-70)',
    '--st-dt-color-status-critical-bg': 'var(--st-dt-color-red-10)',
    '--st-dt-color-status-critical-border-default': 'var(--st-dt-color-red-70)',
    '--st-dt-color-status-critical-icon': 'var(--st-dt-color-red-70)',
    '--st-dt-color-status-bias-bg': 'var(--st-dt-color-pink-10)',
    '--st-dt-color-status-bias-border': 'var(--st-dt-color-pink-70)',
    '--st-dt-color-status-bias-icon': 'var(--st-dt-color-pink-70)',
    '--st-dt-color-status-info-fill': 'var(--st-dt-color-blue-50)',
    '--st-dt-color-status-success-fill': 'var(--st-dt-color-green-50)',
    '--st-dt-color-status-warning-fill': 'var(--st-dt-color-yellow-60)',
    '--st-dt-color-status-critical-fill': 'var(--st-dt-color-red-50)',
    '--st-dt-color-status-bias-fill': 'var(--st-dt-color-pink-50)',
    '--st-dt-color-status-neutral-fill': 'var(--st-dt-color-neutral-50)',
    '--st-dt-color-status-neutral-border': 'var(--st-dt-color-neutral-70)',
    '--st-dt-color-status-success-border-hover': 'var(--st-dt-color-green-60)',
    '--st-dt-color-status-success-border-pressed': 'var(--st-dt-color-green-80)',
    '--st-dt-color-status-warning-border-hover': 'var(--st-dt-color-yellow-60)',
    '--st-dt-color-status-warning-border-pressed': 'var(--st-dt-color-yellow-80)',
    '--st-dt-color-status-critical-border-hover': 'var(--st-dt-color-red-60)',
    '--st-dt-color-status-critical-border-pressed': 'var(--st-dt-color-red-80)',
    '--st-dt-color-status-critical-border-disabled': 'var(--st-dt-color-red-30)',
    '--st-dt-color-status-info-border-disabled': 'var(--st-dt-color-blue-20)',
    '--st-dt-color-tenure-gold': '#85714d',
    '--st-dt-color-tenure-blue': '#379aec',
    '--st-dt-color-tenure-yellow': '#f4980a',
    '--st-dt-color-tenure-red': '#da3733',
    '--st-dt-color-tenure-purple': '#a249e0',
    '--st-dt-color-tenure-silver': '#737e8b',
    '--st-dt-color-transparent-neutral90-alpha30': '#232f3e4d',
    '--st-dt-color-transparent-neutral90-alpha10': '#232f3e1a',
    '--st-dt-color-transparent-neutral90-alpha20': '#232f3e33',
    '--st-dt-color-transparent-neutral100-alpha70': '#161e2db3',
    '--st-dt-color-transparent-alpha0': '#00000000',
    '--st-dt-color-transparent-black-alpha70': '#000000b3',
    '--st-dt-color-transparent-blue70-alpha30': '#1768c94d',
    '--st-dt-color-transparent-blue60-alpha70': '#0077d9b3',
    '--st-dt-color-transparent-blue20-alpha30': '#afd7f74d',
    '--st-dt-color-transparent-red20-alpha30': '#fbc3bf4d',
    '--st-dt-color-transparent-red70-alpha30': '#bb29294d',
    '--st-dt-color-transparent-neutral05-alpha10': '#f1f4f71a',
    '--st-dt-color-transparent-neutral05-alpha20': '#f1f4f733',
    '--st-dt-color-transparent-orange40-alpha30': '#ff84004d',
    '--st-dt-color-transparent-orange50-alpha30': '#ff62004d',
    '--st-dt-color-gradient-elevation': 'var(--st-dt-color-transparent-neutral90-alpha30)',
    '--st-dt-color-cream-10': '#f5efe2',
    '--st-dt-color-cream-20': '#eae2d0',
    '--st-dt-color-cream-30': '#d2c6b0',
    '--st-dt-color-cream-40': '#b4a890',
    '--st-dt-color-cream-50': '#9e917a',
    '--st-dt-color-cream-60': '#90846d',
    '--st-dt-color-cream-70': '#847761',
    '--st-dt-color-cream-80': '#6a5e48',
    '--st-dt-color-cream-90': '#3a2f1b',
    '--st-dt-color-cream-100': '#2d1f00',
    '--st-dt-color-cream-05': '#f5f3ef',
    '--st-dt-color-magenta-10': '#fbe8ff',
    '--st-dt-color-magenta-20': '#f5d6ff',
    '--st-dt-color-magenta-30': '#e6aeff',
    '--st-dt-color-magenta-40': '#d67cff',
    '--st-dt-color-magenta-50': '#c568f2',
    '--st-dt-color-magenta-60': '#b25dea',
    '--st-dt-color-magenta-70': '#a24dd9',
    '--st-dt-color-magenta-80': '#8a3abe',
    '--st-dt-color-magenta-90': '#54007b',
    '--st-dt-color-magenta-05': '#fdf2ff',
    '--st-dt-color-teal-10': '#dffcf9',
    '--st-dt-color-teal-20': '#b1ece7',
    '--st-dt-color-teal-30': '#6fd4cd',
    '--st-dt-color-teal-40': '#00beb7',
    '--st-dt-color-teal-50': '#00a29c',
    '--st-dt-color-teal-60': '#00928a',
    '--st-dt-color-teal-70': '#00857d',
    '--st-dt-color-teal-80': '#006964',
    '--st-dt-color-teal-90': '#003734',
    '--st-dt-color-teal-05': '#f4ffff',
    '--st-dt-color-orange-10': '#fff0cf',
    '--st-dt-color-orange-20': '#ffe4ad',
    '--st-dt-color-orange-30': '#ffb14a',
    '--st-dt-color-orange-40': '#ff8400',
    '--st-dt-color-orange-50': '#ff6200',
    '--st-dt-color-orange-55': '#f55600',
    '--st-dt-color-orange-60': '#e54f00',
    '--st-dt-color-orange-70': '#d14900',
    '--st-dt-color-orange-80': '#9d3011',
    '--st-dt-color-orange-90': '#63170f',
    '--st-dt-color-orange-05': '#fff7e3',
    '--st-dt-color-lavender-10': '#ecedff',
    '--st-dt-color-lavender-20': '#dcdeff',
    '--st-dt-color-lavender-30': '#bdc1ff',
    '--st-dt-color-lavender-40': '#9c9cff',
    '--st-dt-color-lavender-50': '#8680fb',
    '--st-dt-color-lavender-60': '#8680fb',
    '--st-dt-color-lavender-70': '#7368cd',
    '--st-dt-color-lavender-80': '#5b53a0',
    '--st-dt-color-lavender-90': '#302c56',
    '--st-dt-color-lavender-05': '#f5f5ff',
    '--st-dt-color-pictogram-primary': 'var(--st-dt-color-neutral-90)',
    '--st-dt-color-pictogram-accent': 'var(--st-dt-color-blue-60)',
    '--st-dt-color-pictogram-bg': 'var(--st-dt-color-neutral-05)',
    '--st-dt-dimensions-border-radius-50': '2px',
    '--st-dt-dimensions-border-radius-100': '4px',
    '--st-dt-dimensions-border-radius-200': '8px',
    '--st-dt-dimensions-border-radius-300': '12px',
    '--st-dt-dimensions-border-radius-400': '16px',
    '--st-dt-dimensions-border-radius-none': '0px',
    '--st-dt-dimensions-border-radius-round': '100px',
    '--st-dt-dimensions-border-width-100': '1px',
    '--st-dt-dimensions-border-width-200': '2px',
    '--st-dt-dimensions-border-width-300': '3px',
    '--st-dt-dimensions-border-width-400': '4px',
    '--st-dt-dimensions-border-width-500': '8px',
    '--st-dt-dimensions-border-width-none': '0px',
    '--st-dt-dimensions-z-index-100': 100,
    '--st-dt-dimensions-z-index-200': 200,
    '--st-dt-dimensions-z-index-300': 300,
    '--st-dt-dimensions-z-index-400': 400,
    '--st-dt-dimensions-z-index-500': 500,
    '--st-dt-dimensions-z-index-600': 600,
    '--st-dt-dimensions-z-index-700': 700,
    '--st-dt-dimensions-z-index-800': 800,
    '--st-dt-dimensions-z-index-900': 900,
    '--st-dt-dimensions-z-index-1000': 1000,
    '--st-dt-dimensions-spacing-50': '2px',
    '--st-dt-dimensions-spacing-100': '4px',
    '--st-dt-dimensions-spacing-200': '8px',
    '--st-dt-dimensions-spacing-250': '12px',
    '--st-dt-dimensions-spacing-300': '16px',
    '--st-dt-dimensions-spacing-400': '24px',
    '--st-dt-dimensions-spacing-500': '32px',
    '--st-dt-dimensions-spacing-600': '48px',
    '--st-dt-dimensions-spacing-700': '64px',
    '--st-dt-dimensions-spacing-800': '80px',
    '--st-dt-dimensions-spacing-none': '0px',
    '--st-dt-shadow-100': 'rgba(35, 47, 62, 0.3) 0px 0px 10px 0px ',
    '--st-dt-shadow-200': 'rgba(35, 47, 62, 0.3) 0px 0px 20px 0px ',
    '--st-dt-shadow-300': 'rgba(0, 0, 0, 0.7) 0px 0px 10px 0px ',
    '--st-dt-shadow-400': 'rgba(0, 0, 0, 0.7) 0px 0px 20px 0px ',
    '--st-dt-shadow-raised-rest': 'var(--st-dt-shadow-100)',
    '--st-dt-shadow-raised-hover': 'var(--st-dt-shadow-200)',
    '--st-dt-shadow-raised-pressed': 'var(--st-dt-shadow-100)',
    '--st-dt-shadow-none': '0px 0px 0px 0px '
  },
  '[data-stencil-prefers-color-scheme=dark]': {
    '--st-dt-text-size-50': '0.75rem',
    '--st-dt-text-size-100': '0.875rem',
    '--st-dt-text-size-200': '1rem',
    '--st-dt-text-size-300': '1.125rem',
    '--st-dt-text-size-400': '1.25rem',
    '--st-dt-text-size-500': '1.375rem',
    '--st-dt-text-size-600': '1.5rem',
    '--st-dt-text-size-700': '1.75rem',
    '--st-dt-text-size-800': '2rem',
    '--st-dt-text-size-900': '2.5rem',
    '--st-dt-text-style-italic': 'italic',
    '--st-dt-text-family-default': 'Amazon Ember',
    '--st-dt-text-family-modernDisplay': 'Ember Modern Display Standard',
    '--st-dt-text-family-modernText': 'Amazon Ember',
    '--st-dt-text-lineHeight-50': '1.125rem',
    '--st-dt-text-lineHeight-100': '1.3125rem',
    '--st-dt-text-lineHeight-150': '1.4375rem',
    '--st-dt-text-lineHeight-200': '1.5rem',
    '--st-dt-text-lineHeight-250': '1.625rem',
    '--st-dt-text-lineHeight-300': '1.6875rem',
    '--st-dt-text-lineHeight-400': '1.8125rem',
    '--st-dt-text-lineHeight-500': '1.9375rem',
    '--st-dt-text-lineHeight-600': '2.25rem',
    '--st-dt-text-lineHeight-700': '2.625rem',
    '--st-dt-text-lineHeight-800': '3.25rem',
    '--st-dt-text-display-size-breakpoint-xl': 'var(--st-dt-text-size-900)',
    '--st-dt-text-display-size-breakpoint-lg': 'var(--st-dt-text-size-900)',
    '--st-dt-text-display-size-breakpoint-md': 'var(--st-dt-text-size-800)',
    '--st-dt-text-display-size-breakpoint-sm': 'var(--st-dt-text-size-800)',
    '--st-dt-text-display-weight-breakpoint-xl': 'var(--st-dt-text-weight-bold)',
    '--st-dt-text-display-weight-breakpoint-lg': 'var(--st-dt-text-weight-bold)',
    '--st-dt-text-display-weight-breakpoint-md': 'var(--st-dt-text-weight-bold)',
    '--st-dt-text-display-weight-breakpoint-sm': 'var(--st-dt-text-weight-bold)',
    '--st-dt-text-display-lineHeight-breakpoint-xl': 'var(--st-dt-text-lineHeight-800)',
    '--st-dt-text-display-lineHeight-breakpoint-lg': 'var(--st-dt-text-lineHeight-800)',
    '--st-dt-text-display-lineHeight-breakpoint-md': 'var(--st-dt-text-lineHeight-700)',
    '--st-dt-text-display-lineHeight-breakpoint-sm': 'var(--st-dt-text-lineHeight-700)',
    '--st-dt-text-display-family-breakpoint-xl': 'var(--st-dt-text-family-default)',
    '--st-dt-text-display-family-breakpoint-lg': 'var(--st-dt-text-family-default)',
    '--st-dt-text-display-family-breakpoint-md': 'var(--st-dt-text-family-default)',
    '--st-dt-text-display-family-breakpoint-sm': 'var(--st-dt-text-family-default)',
    '--st-dt-text-weight-regular': 400,
    '--st-dt-text-weight-medium': 500,
    '--st-dt-text-weight-bold': 700,
    '--st-dt-text-heading-xl-size-breakpoint-xl': 'var(--st-dt-text-size-800)',
    '--st-dt-text-heading-xl-size-breakpoint-lg': 'var(--st-dt-text-size-800)',
    '--st-dt-text-heading-xl-size-breakpoint-md': 'var(--st-dt-text-size-700)',
    '--st-dt-text-heading-xl-size-breakpoint-sm': 'var(--st-dt-text-size-700)',
    '--st-dt-text-heading-xl-weight-breakpoint-xl': 'var(--st-dt-text-weight-bold)',
    '--st-dt-text-heading-xl-weight-breakpoint-lg': 'var(--st-dt-text-weight-bold)',
    '--st-dt-text-heading-xl-weight-breakpoint-md': 'var(--st-dt-text-weight-bold)',
    '--st-dt-text-heading-xl-weight-breakpoint-sm': 'var(--st-dt-text-weight-bold)',
    '--st-dt-text-heading-xl-lineHeight-breakpoint-xl': 'var(--st-dt-text-lineHeight-700)',
    '--st-dt-text-heading-xl-lineHeight-breakpoint-lg': 'var(--st-dt-text-lineHeight-700)',
    '--st-dt-text-heading-xl-lineHeight-breakpoint-md': 'var(--st-dt-text-lineHeight-600)',
    '--st-dt-text-heading-xl-lineHeight-breakpoint-sm': 'var(--st-dt-text-lineHeight-600)',
    '--st-dt-text-heading-xl-family-breakpoint-xl': 'var(--st-dt-text-family-default)',
    '--st-dt-text-heading-xl-family-breakpoint-lg': 'var(--st-dt-text-family-default)',
    '--st-dt-text-heading-xl-family-breakpoint-md': 'var(--st-dt-text-family-default)',
    '--st-dt-text-heading-xl-family-breakpoint-sm': 'var(--st-dt-text-family-default)',
    '--st-dt-text-heading-lg-size-breakpoint-xl': 'var(--st-dt-text-size-600)',
    '--st-dt-text-heading-lg-size-breakpoint-lg': 'var(--st-dt-text-size-600)',
    '--st-dt-text-heading-lg-size-breakpoint-md': 'var(--st-dt-text-size-500)',
    '--st-dt-text-heading-lg-size-breakpoint-sm': 'var(--st-dt-text-size-500)',
    '--st-dt-text-heading-lg-weight-breakpoint-xl': 'var(--st-dt-text-weight-bold)',
    '--st-dt-text-heading-lg-weight-breakpoint-lg': 'var(--st-dt-text-weight-bold)',
    '--st-dt-text-heading-lg-weight-breakpoint-md': 'var(--st-dt-text-weight-bold)',
    '--st-dt-text-heading-lg-weight-breakpoint-sm': 'var(--st-dt-text-weight-bold)',
    '--st-dt-text-heading-lg-lineHeight-breakpoint-xl': 'var(--st-dt-text-lineHeight-500)',
    '--st-dt-text-heading-lg-lineHeight-breakpoint-lg': 'var(--st-dt-text-lineHeight-500)',
    '--st-dt-text-heading-lg-lineHeight-breakpoint-md': 'var(--st-dt-text-lineHeight-400)',
    '--st-dt-text-heading-lg-lineHeight-breakpoint-sm': 'var(--st-dt-text-lineHeight-400)',
    '--st-dt-text-heading-lg-family-breakpoint-xl': 'var(--st-dt-text-family-default)',
    '--st-dt-text-heading-lg-family-breakpoint-lg': 'var(--st-dt-text-family-default)',
    '--st-dt-text-heading-lg-family-breakpoint-md': 'var(--st-dt-text-family-default)',
    '--st-dt-text-heading-lg-family-breakpoint-sm': 'var(--st-dt-text-family-default)',
    '--st-dt-text-heading-md-size-breakpoint-xl': 'var(--st-dt-text-size-400)',
    '--st-dt-text-heading-md-size-breakpoint-lg': 'var(--st-dt-text-size-400)',
    '--st-dt-text-heading-md-size-breakpoint-md': 'var(--st-dt-text-size-300)',
    '--st-dt-text-heading-md-size-breakpoint-sm': 'var(--st-dt-text-size-300)',
    '--st-dt-text-heading-md-weight-breakpoint-xl': 'var(--st-dt-text-weight-bold)',
    '--st-dt-text-heading-md-weight-breakpoint-lg': 'var(--st-dt-text-weight-bold)',
    '--st-dt-text-heading-md-weight-breakpoint-md': 'var(--st-dt-text-weight-bold)',
    '--st-dt-text-heading-md-weight-breakpoint-sm': 'var(--st-dt-text-weight-bold)',
    '--st-dt-text-heading-md-lineHeight-breakpoint-xl': 'var(--st-dt-text-lineHeight-250)',
    '--st-dt-text-heading-md-lineHeight-breakpoint-lg': 'var(--st-dt-text-lineHeight-250)',
    '--st-dt-text-heading-md-lineHeight-breakpoint-md': 'var(--st-dt-text-lineHeight-150)',
    '--st-dt-text-heading-md-lineHeight-breakpoint-sm': 'var(--st-dt-text-lineHeight-150)',
    '--st-dt-text-heading-md-family-breakpoint-xl': 'var(--st-dt-text-family-default)',
    '--st-dt-text-heading-md-family-breakpoint-lg': 'var(--st-dt-text-family-default)',
    '--st-dt-text-heading-md-family-breakpoint-md': 'var(--st-dt-text-family-default)',
    '--st-dt-text-heading-md-family-breakpoint-sm': 'var(--st-dt-text-family-default)',
    '--st-dt-text-heading-sm-size-breakpoint-xl': 'var(--st-dt-text-size-200)',
    '--st-dt-text-heading-sm-size-breakpoint-lg': 'var(--st-dt-text-size-200)',
    '--st-dt-text-heading-sm-size-breakpoint-md': 'var(--st-dt-text-size-200)',
    '--st-dt-text-heading-sm-size-breakpoint-sm': 'var(--st-dt-text-size-200)',
    '--st-dt-text-heading-sm-weight-breakpoint-xl': 'var(--st-dt-text-weight-bold)',
    '--st-dt-text-heading-sm-weight-breakpoint-lg': 'var(--st-dt-text-weight-bold)',
    '--st-dt-text-heading-sm-weight-breakpoint-md': 'var(--st-dt-text-weight-bold)',
    '--st-dt-text-heading-sm-weight-breakpoint-sm': 'var(--st-dt-text-weight-bold)',
    '--st-dt-text-heading-sm-lineHeight-breakpoint-xl': 'var(--st-dt-text-lineHeight-100)',
    '--st-dt-text-heading-sm-lineHeight-breakpoint-lg': 'var(--st-dt-text-lineHeight-100)',
    '--st-dt-text-heading-sm-lineHeight-breakpoint-md': 'var(--st-dt-text-lineHeight-100)',
    '--st-dt-text-heading-sm-lineHeight-breakpoint-sm': 'var(--st-dt-text-lineHeight-100)',
    '--st-dt-text-heading-sm-family-breakpoint-xl': 'var(--st-dt-text-family-default)',
    '--st-dt-text-heading-sm-family-breakpoint-lg': 'var(--st-dt-text-family-default)',
    '--st-dt-text-heading-sm-family-breakpoint-md': 'var(--st-dt-text-family-default)',
    '--st-dt-text-heading-sm-family-breakpoint-sm': 'var(--st-dt-text-family-default)',
    '--st-dt-text-heading-xs-size-breakpoint-xl': 'var(--st-dt-text-size-100)',
    '--st-dt-text-heading-xs-size-breakpoint-lg': 'var(--st-dt-text-size-100)',
    '--st-dt-text-heading-xs-size-breakpoint-md': 'var(--st-dt-text-size-100)',
    '--st-dt-text-heading-xs-size-breakpoint-sm': 'var(--st-dt-text-size-100)',
    '--st-dt-text-heading-xs-weight-breakpoint-xl': 'var(--st-dt-text-weight-bold)',
    '--st-dt-text-heading-xs-weight-breakpoint-lg': 'var(--st-dt-text-weight-bold)',
    '--st-dt-text-heading-xs-weight-breakpoint-md': 'var(--st-dt-text-weight-bold)',
    '--st-dt-text-heading-xs-weight-breakpoint-sm': 'var(--st-dt-text-weight-bold)',
    '--st-dt-text-heading-xs-lineHeight-breakpoint-xl': 'var(--st-dt-text-lineHeight-50)',
    '--st-dt-text-heading-xs-lineHeight-breakpoint-lg': 'var(--st-dt-text-lineHeight-50)',
    '--st-dt-text-heading-xs-lineHeight-breakpoint-md': 'var(--st-dt-text-lineHeight-50)',
    '--st-dt-text-heading-xs-lineHeight-breakpoint-sm': 'var(--st-dt-text-lineHeight-50)',
    '--st-dt-text-heading-xs-family-breakpoint-xl': 'var(--st-dt-text-family-default)',
    '--st-dt-text-heading-xs-family-breakpoint-lg': 'var(--st-dt-text-family-default)',
    '--st-dt-text-heading-xs-family-breakpoint-md': 'var(--st-dt-text-family-default)',
    '--st-dt-text-heading-xs-family-breakpoint-sm': 'var(--st-dt-text-family-default)',
    '--st-dt-text-heading-xxs-size-breakpoint-xl': 'var(--st-dt-text-size-100)',
    '--st-dt-text-heading-xxs-size-breakpoint-lg': 'var(--st-dt-text-size-100)',
    '--st-dt-text-heading-xxs-size-breakpoint-md': 'var(--st-dt-text-size-100)',
    '--st-dt-text-heading-xxs-size-breakpoint-sm': 'var(--st-dt-text-size-100)',
    '--st-dt-text-heading-xxs-weight-breakpoint-xl': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-heading-xxs-weight-breakpoint-lg': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-heading-xxs-weight-breakpoint-md': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-heading-xxs-weight-breakpoint-sm': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-heading-xxs-lineHeight-breakpoint-xl': 'var(--st-dt-text-lineHeight-50)',
    '--st-dt-text-heading-xxs-lineHeight-breakpoint-lg': 'var(--st-dt-text-lineHeight-50)',
    '--st-dt-text-heading-xxs-lineHeight-breakpoint-md': 'var(--st-dt-text-lineHeight-50)',
    '--st-dt-text-heading-xxs-lineHeight-breakpoint-sm': 'var(--st-dt-text-lineHeight-50)',
    '--st-dt-text-heading-xxs-family-breakpoint-xl': 'var(--st-dt-text-family-default)',
    '--st-dt-text-heading-xxs-family-breakpoint-lg': 'var(--st-dt-text-family-default)',
    '--st-dt-text-heading-xxs-family-breakpoint-md': 'var(--st-dt-text-family-default)',
    '--st-dt-text-heading-xxs-family-breakpoint-sm': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-md-size-breakpoint-xl': 'var(--st-dt-text-size-200)',
    '--st-dt-text-body-md-size-breakpoint-lg': 'var(--st-dt-text-size-200)',
    '--st-dt-text-body-md-size-breakpoint-md': 'var(--st-dt-text-size-200)',
    '--st-dt-text-body-md-size-breakpoint-sm': 'var(--st-dt-text-size-200)',
    '--st-dt-text-body-md-weight-breakpoint-xl': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-body-md-weight-breakpoint-lg': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-body-md-weight-breakpoint-md': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-body-md-weight-breakpoint-sm': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-body-md-lineHeight-breakpoint-xl': 'var(--st-dt-text-lineHeight-200)',
    '--st-dt-text-body-md-lineHeight-breakpoint-lg': 'var(--st-dt-text-lineHeight-200)',
    '--st-dt-text-body-md-lineHeight-breakpoint-md': 'var(--st-dt-text-lineHeight-200)',
    '--st-dt-text-body-md-lineHeight-breakpoint-sm': 'var(--st-dt-text-lineHeight-200)',
    '--st-dt-text-body-md-family-breakpoint-xl': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-md-family-breakpoint-lg': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-md-family-breakpoint-md': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-md-family-breakpoint-sm': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-sm-size-breakpoint-xl': 'var(--st-dt-text-size-100)',
    '--st-dt-text-body-sm-size-breakpoint-lg': 'var(--st-dt-text-size-100)',
    '--st-dt-text-body-sm-size-breakpoint-md': 'var(--st-dt-text-size-100)',
    '--st-dt-text-body-sm-size-breakpoint-sm': 'var(--st-dt-text-size-100)',
    '--st-dt-text-body-sm-weight-breakpoint-xl': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-body-sm-weight-breakpoint-lg': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-body-sm-weight-breakpoint-md': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-body-sm-weight-breakpoint-sm': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-body-sm-lineHeight-breakpoint-xl': 'var(--st-dt-text-lineHeight-100)',
    '--st-dt-text-body-sm-lineHeight-breakpoint-lg': 'var(--st-dt-text-lineHeight-100)',
    '--st-dt-text-body-sm-lineHeight-breakpoint-md': 'var(--st-dt-text-lineHeight-100)',
    '--st-dt-text-body-sm-lineHeight-breakpoint-sm': 'var(--st-dt-text-lineHeight-100)',
    '--st-dt-text-body-sm-family-breakpoint-xl': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-sm-family-breakpoint-lg': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-sm-family-breakpoint-md': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-sm-family-breakpoint-sm': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-hint-size-breakpoint-xl': 'var(--st-dt-text-size-200)',
    '--st-dt-text-body-hint-size-breakpoint-lg': 'var(--st-dt-text-size-200)',
    '--st-dt-text-body-hint-size-breakpoint-md': 'var(--st-dt-text-size-200)',
    '--st-dt-text-body-hint-size-breakpoint-sm': 'var(--st-dt-text-size-200)',
    '--st-dt-text-body-hint-weight-breakpoint-xl': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-body-hint-weight-breakpoint-lg': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-body-hint-weight-breakpoint-md': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-body-hint-weight-breakpoint-sm': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-body-hint-lineHeight-breakpoint-xl': 'var(--st-dt-text-lineHeight-200)',
    '--st-dt-text-body-hint-lineHeight-breakpoint-lg': 'var(--st-dt-text-lineHeight-200)',
    '--st-dt-text-body-hint-lineHeight-breakpoint-md': 'var(--st-dt-text-lineHeight-200)',
    '--st-dt-text-body-hint-lineHeight-breakpoint-sm': 'var(--st-dt-text-lineHeight-200)',
    '--st-dt-text-body-hint-style-breakpoint-xl': 'var(--st-dt-text-style-italic)',
    '--st-dt-text-body-hint-style-breakpoint-lg': 'var(--st-dt-text-style-italic)',
    '--st-dt-text-body-hint-style-breakpoint-md': 'var(--st-dt-text-style-italic)',
    '--st-dt-text-body-hint-style-breakpoint-sm': 'var(--st-dt-text-style-italic)',
    '--st-dt-text-body-hint-family-breakpoint-xl': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-hint-family-breakpoint-lg': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-hint-family-breakpoint-md': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-hint-family-breakpoint-sm': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-lg-size-breakpoint-xl': 'var(--st-dt-text-size-300)',
    '--st-dt-text-body-lg-size-breakpoint-lg': 'var(--st-dt-text-size-300)',
    '--st-dt-text-body-lg-size-breakpoint-md': 'var(--st-dt-text-size-300)',
    '--st-dt-text-body-lg-size-breakpoint-sm': 'var(--st-dt-text-size-300)',
    '--st-dt-text-body-lg-weight-breakpoint-xl': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-body-lg-weight-breakpoint-lg': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-body-lg-weight-breakpoint-md': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-body-lg-weight-breakpoint-sm': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-body-lg-lineHeight-breakpoint-xl': 'var(--st-dt-text-lineHeight-300)',
    '--st-dt-text-body-lg-lineHeight-breakpoint-lg': 'var(--st-dt-text-lineHeight-300)',
    '--st-dt-text-body-lg-lineHeight-breakpoint-md': 'var(--st-dt-text-lineHeight-300)',
    '--st-dt-text-body-lg-lineHeight-breakpoint-sm': 'var(--st-dt-text-lineHeight-300)',
    '--st-dt-text-body-lg-family-breakpoint-xl': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-lg-family-breakpoint-lg': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-lg-family-breakpoint-md': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-lg-family-breakpoint-sm': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-sm-interactive-size-breakpoint-xl': 'var(--st-dt-text-size-100)',
    '--st-dt-text-body-sm-interactive-size-breakpoint-lg': 'var(--st-dt-text-size-100)',
    '--st-dt-text-body-sm-interactive-size-breakpoint-md': 'var(--st-dt-text-size-100)',
    '--st-dt-text-body-sm-interactive-size-breakpoint-sm': 'var(--st-dt-text-size-100)',
    '--st-dt-text-body-sm-interactive-weight-breakpoint-xl': 'var(--st-dt-text-weight-medium)',
    '--st-dt-text-body-sm-interactive-weight-breakpoint-lg': 'var(--st-dt-text-weight-medium)',
    '--st-dt-text-body-sm-interactive-weight-breakpoint-md': 'var(--st-dt-text-weight-medium)',
    '--st-dt-text-body-sm-interactive-weight-breakpoint-sm': 'var(--st-dt-text-weight-medium)',
    '--st-dt-text-body-sm-interactive-lineHeight-breakpoint-xl': 'var(--st-dt-text-lineHeight-100)',
    '--st-dt-text-body-sm-interactive-lineHeight-breakpoint-lg': 'var(--st-dt-text-lineHeight-100)',
    '--st-dt-text-body-sm-interactive-lineHeight-breakpoint-md': 'var(--st-dt-text-lineHeight-100)',
    '--st-dt-text-body-sm-interactive-lineHeight-breakpoint-sm': 'var(--st-dt-text-lineHeight-100)',
    '--st-dt-text-body-sm-interactive-family-breakpoint-xl': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-sm-interactive-family-breakpoint-lg': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-sm-interactive-family-breakpoint-md': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-sm-interactive-family-breakpoint-sm': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-md-interactive-size-breakpoint-xl': 'var(--st-dt-text-size-200)',
    '--st-dt-text-body-md-interactive-size-breakpoint-lg': 'var(--st-dt-text-size-200)',
    '--st-dt-text-body-md-interactive-size-breakpoint-md': 'var(--st-dt-text-size-200)',
    '--st-dt-text-body-md-interactive-size-breakpoint-sm': 'var(--st-dt-text-size-200)',
    '--st-dt-text-body-md-interactive-weight-breakpoint-xl': 'var(--st-dt-text-weight-medium)',
    '--st-dt-text-body-md-interactive-weight-breakpoint-lg': 'var(--st-dt-text-weight-medium)',
    '--st-dt-text-body-md-interactive-weight-breakpoint-md': 'var(--st-dt-text-weight-medium)',
    '--st-dt-text-body-md-interactive-weight-breakpoint-sm': 'var(--st-dt-text-weight-medium)',
    '--st-dt-text-body-md-interactive-lineHeight-breakpoint-xl': 'var(--st-dt-text-lineHeight-200)',
    '--st-dt-text-body-md-interactive-lineHeight-breakpoint-lg': 'var(--st-dt-text-lineHeight-200)',
    '--st-dt-text-body-md-interactive-lineHeight-breakpoint-md': 'var(--st-dt-text-lineHeight-200)',
    '--st-dt-text-body-md-interactive-lineHeight-breakpoint-sm': 'var(--st-dt-text-lineHeight-200)',
    '--st-dt-text-body-md-interactive-family-breakpoint-xl': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-md-interactive-family-breakpoint-lg': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-md-interactive-family-breakpoint-md': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-md-interactive-family-breakpoint-sm': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-lg-interactive-size-breakpoint-xl': 'var(--st-dt-text-size-300)',
    '--st-dt-text-body-lg-interactive-size-breakpoint-lg': 'var(--st-dt-text-size-300)',
    '--st-dt-text-body-lg-interactive-size-breakpoint-md': 'var(--st-dt-text-size-300)',
    '--st-dt-text-body-lg-interactive-size-breakpoint-sm': 'var(--st-dt-text-size-300)',
    '--st-dt-text-body-lg-interactive-weight-breakpoint-xl': 'var(--st-dt-text-weight-medium)',
    '--st-dt-text-body-lg-interactive-weight-breakpoint-lg': 'var(--st-dt-text-weight-medium)',
    '--st-dt-text-body-lg-interactive-weight-breakpoint-md': 'var(--st-dt-text-weight-medium)',
    '--st-dt-text-body-lg-interactive-weight-breakpoint-sm': 'var(--st-dt-text-weight-medium)',
    '--st-dt-text-body-lg-interactive-lineHeight-breakpoint-xl': 'var(--st-dt-text-lineHeight-300)',
    '--st-dt-text-body-lg-interactive-lineHeight-breakpoint-lg': 'var(--st-dt-text-lineHeight-300)',
    '--st-dt-text-body-lg-interactive-lineHeight-breakpoint-md': 'var(--st-dt-text-lineHeight-300)',
    '--st-dt-text-body-lg-interactive-lineHeight-breakpoint-sm': 'var(--st-dt-text-lineHeight-300)',
    '--st-dt-text-body-lg-interactive-family-breakpoint-xl': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-lg-interactive-family-breakpoint-lg': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-lg-interactive-family-breakpoint-md': 'var(--st-dt-text-family-default)',
    '--st-dt-text-body-lg-interactive-family-breakpoint-sm': 'var(--st-dt-text-family-default)',
    '--st-dt-text-label-md-size-breakpoint-xl': 'var(--st-dt-text-size-200)',
    '--st-dt-text-label-md-size-breakpoint-lg': 'var(--st-dt-text-size-200)',
    '--st-dt-text-label-md-size-breakpoint-md': 'var(--st-dt-text-size-200)',
    '--st-dt-text-label-md-size-breakpoint-sm': 'var(--st-dt-text-size-200)',
    '--st-dt-text-label-md-weight-breakpoint-xl': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-label-md-weight-breakpoint-lg': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-label-md-weight-breakpoint-md': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-label-md-weight-breakpoint-sm': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-label-md-lineHeight-breakpoint-xl': 'var(--st-dt-text-lineHeight-200)',
    '--st-dt-text-label-md-lineHeight-breakpoint-lg': 'var(--st-dt-text-lineHeight-200)',
    '--st-dt-text-label-md-lineHeight-breakpoint-md': 'var(--st-dt-text-lineHeight-200)',
    '--st-dt-text-label-md-lineHeight-breakpoint-sm': 'var(--st-dt-text-lineHeight-200)',
    '--st-dt-text-label-md-family-breakpoint-xl': 'var(--st-dt-text-family-default)',
    '--st-dt-text-label-md-family-breakpoint-lg': 'var(--st-dt-text-family-default)',
    '--st-dt-text-label-md-family-breakpoint-md': 'var(--st-dt-text-family-default)',
    '--st-dt-text-label-md-family-breakpoint-sm': 'var(--st-dt-text-family-default)',
    '--st-dt-text-label-sm-size-breakpoint-xl': 'var(--st-dt-text-size-100)',
    '--st-dt-text-label-sm-size-breakpoint-lg': 'var(--st-dt-text-size-100)',
    '--st-dt-text-label-sm-size-breakpoint-md': 'var(--st-dt-text-size-100)',
    '--st-dt-text-label-sm-size-breakpoint-sm': 'var(--st-dt-text-size-100)',
    '--st-dt-text-label-sm-weight-breakpoint-xl': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-label-sm-weight-breakpoint-lg': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-label-sm-weight-breakpoint-md': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-label-sm-weight-breakpoint-sm': 'var(--st-dt-text-weight-regular)',
    '--st-dt-text-label-sm-lineHeight-breakpoint-xl': 'var(--st-dt-text-lineHeight-100)',
    '--st-dt-text-label-sm-lineHeight-breakpoint-lg': 'var(--st-dt-text-lineHeight-100)',
    '--st-dt-text-label-sm-lineHeight-breakpoint-md': 'var(--st-dt-text-lineHeight-100)',
    '--st-dt-text-label-sm-lineHeight-breakpoint-sm': 'var(--st-dt-text-lineHeight-100)',
    '--st-dt-text-label-sm-family-breakpoint-xl': 'var(--st-dt-text-family-default)',
    '--st-dt-text-label-sm-family-breakpoint-lg': 'var(--st-dt-text-family-default)',
    '--st-dt-text-label-sm-family-breakpoint-md': 'var(--st-dt-text-family-default)',
    '--st-dt-text-label-sm-family-breakpoint-sm': 'var(--st-dt-text-family-default)',
    '--st-dt-text-label-xs-size-breakpoint-xl': 'var(--st-dt-text-size-50)',
    '--st-dt-text-label-xs-size-breakpoint-lg': 'var(--st-dt-text-size-50)',
    '--st-dt-text-label-xs-size-breakpoint-md': 'var(--st-dt-text-size-50)',
    '--st-dt-text-label-xs-size-breakpoint-sm': 'var(--st-dt-text-size-50)',
    '--st-dt-text-label-xs-weight-breakpoint-xl': 'var(--st-dt-text-weight-medium)',
    '--st-dt-text-label-xs-weight-breakpoint-lg': 'var(--st-dt-text-weight-medium)',
    '--st-dt-text-label-xs-weight-breakpoint-md': 'var(--st-dt-text-weight-medium)',
    '--st-dt-text-label-xs-weight-breakpoint-sm': 'var(--st-dt-text-weight-medium)',
    '--st-dt-text-label-xs-lineHeight-breakpoint-xl': 'var(--st-dt-text-lineHeight-50)',
    '--st-dt-text-label-xs-lineHeight-breakpoint-lg': 'var(--st-dt-text-lineHeight-50)',
    '--st-dt-text-label-xs-lineHeight-breakpoint-md': 'var(--st-dt-text-lineHeight-50)',
    '--st-dt-text-label-xs-lineHeight-breakpoint-sm': 'var(--st-dt-text-lineHeight-50)',
    '--st-dt-text-label-xs-family-breakpoint-xl': 'var(--st-dt-text-family-default)',
    '--st-dt-text-label-xs-family-breakpoint-lg': 'var(--st-dt-text-family-default)',
    '--st-dt-text-label-xs-family-breakpoint-md': 'var(--st-dt-text-family-default)',
    '--st-dt-text-label-xs-family-breakpoint-sm': 'var(--st-dt-text-family-default)',
    '--st-dt-color-neutral-10': '#e8eaee',
    '--st-dt-color-neutral-20': '#d1d5da',
    '--st-dt-color-neutral-30': '#b9c0c8',
    '--st-dt-color-neutral-40': '#a2abb5',
    '--st-dt-color-neutral-50': '#8b96a3',
    '--st-dt-color-neutral-60': '#737e8b',
    '--st-dt-color-neutral-70': '#56616c',
    '--st-dt-color-neutral-80': '#394451',
    '--st-dt-color-neutral-90': '#232f3e',
    '--st-dt-color-neutral-100': '#161e2d',
    '--st-dt-color-neutral-00': '#ffffff',
    '--st-dt-color-neutral-05': '#f1f4f7',
    '--st-dt-color-blue-10': '#d7ebfb',
    '--st-dt-color-blue-20': '#afd7f7',
    '--st-dt-color-blue-30': '#87c2f4',
    '--st-dt-color-blue-40': '#5faef0',
    '--st-dt-color-blue-50': '#379aec',
    '--st-dt-color-blue-60': '#0077d9',
    '--st-dt-color-blue-70': '#1768c9',
    '--st-dt-color-blue-80': '#1659a9',
    '--st-dt-color-blue-90': '#123b74',
    '--st-dt-color-blue-05': '#ebf5fd',
    '--st-dt-color-green-10': '#d7f3ed',
    '--st-dt-color-green-20': '#afe7db',
    '--st-dt-color-green-30': '#86dac9',
    '--st-dt-color-green-40': '#5eceb7',
    '--st-dt-color-green-50': '#00a890',
    '--st-dt-color-green-60': '#008574',
    '--st-dt-color-green-70': '#23756b',
    '--st-dt-color-green-80': '#195f57',
    '--st-dt-color-green-90': '#104643',
    '--st-dt-color-green-05': '#ebf9f6',
    '--st-dt-color-red-10': '#fde1df',
    '--st-dt-color-red-20': '#fbc3bf',
    '--st-dt-color-red-30': '#f8a49e',
    '--st-dt-color-red-40': '#f6867e',
    '--st-dt-color-red-50': '#f4685e',
    '--st-dt-color-red-60': '#da3733',
    '--st-dt-color-red-70': '#bb2929',
    '--st-dt-color-red-80': '#9a1818',
    '--st-dt-color-red-90': '#710400',
    '--st-dt-color-red-05': '#fef0ef',
    '--st-dt-color-yellow-10': '#fff3cc',
    '--st-dt-color-yellow-20': '#ffe799',
    '--st-dt-color-yellow-30': '#ffdc66',
    '--st-dt-color-yellow-40': '#ffd033',
    '--st-dt-color-yellow-50': '#ffc400',
    '--st-dt-color-yellow-60': '#ca8700',
    '--st-dt-color-yellow-70': '#b27400',
    '--st-dt-color-yellow-80': '#8e5d00',
    '--st-dt-color-yellow-90': '#684500',
    '--st-dt-color-yellow-05': '#fff9e6',
    '--st-dt-color-pink-10': '#f3deeb',
    '--st-dt-color-pink-20': '#e8bdd7',
    '--st-dt-color-pink-30': '#dd9cc4',
    '--st-dt-color-pink-40': '#d27bb0',
    '--st-dt-color-pink-50': '#cf6ba0',
    '--st-dt-color-pink-60': '#ba3385',
    '--st-dt-color-pink-70': '#a90067',
    '--st-dt-color-pink-80': '#8b065b',
    '--st-dt-color-pink-90': '#6e0c4f',
    '--st-dt-color-pink-05': '#faf2f7',
    '--st-dt-color-purple-10': '#f2e4fb',
    '--st-dt-color-purple-20': '#e5c8f7',
    '--st-dt-color-purple-30': '#d9adf2',
    '--st-dt-color-purple-40': '#cc91ee',
    '--st-dt-color-purple-50': '#bf76ea',
    '--st-dt-color-purple-60': '#a249e0',
    '--st-dt-color-purple-70': '#8b46c6',
    '--st-dt-color-purple-80': '#7037a3',
    '--st-dt-color-purple-90': '#51267f',
    '--st-dt-color-purple-05': '#f9f1fd',
    '--st-dt-color-surface-bg-default': 'var(--st-dt-color-neutral-100)',
    '--st-dt-color-surface-bg-muted': 'var(--st-dt-color-neutral-90)',
    '--st-dt-color-surface-overlay': 'var(--st-dt-color-transparent-black-alpha70)',
    '--st-dt-color-surface-dark-bg-static': 'var(--st-dt-color-neutral-90)',
    '--st-dt-color-surface-bg-raised': 'var(--st-dt-color-neutral-90)',
    '--st-dt-color-fill-neutral-primary': 'var(--st-dt-color-neutral-100)',
    '--st-dt-color-fill-neutral-muted': 'var(--st-dt-color-neutral-90)',
    '--st-dt-color-fill-neutral-secondary': 'var(--st-dt-color-neutral-80)',
    '--st-dt-color-fill-neutral-tertiary': 'var(--st-dt-color-neutral-70)',
    '--st-dt-color-fill-vibrant-gray': 'var(--st-dt-color-neutral-50)',
    '--st-dt-color-fill-vibrant-blue': 'var(--st-dt-color-blue-50)',
    '--st-dt-color-fill-vibrant-red': 'var(--st-dt-color-red-50)',
    '--st-dt-color-fill-vibrant-green': 'var(--st-dt-color-green-50)',
    '--st-dt-color-fill-vibrant-yellow': 'var(--st-dt-color-yellow-50)',
    '--st-dt-color-fill-vibrant-purple': 'var(--st-dt-color-purple-50)',
    '--st-dt-color-fill-vibrant-pink': 'var(--st-dt-color-pink-50)',
    '--st-dt-color-fill-muted-gray': 'var(--st-dt-color-neutral-80)',
    '--st-dt-color-fill-muted-blue': 'var(--st-dt-color-blue-90)',
    '--st-dt-color-fill-muted-red': 'var(--st-dt-color-red-90)',
    '--st-dt-color-fill-muted-green': 'var(--st-dt-color-green-90)',
    '--st-dt-color-fill-muted-yellow': 'var(--st-dt-color-yellow-90)',
    '--st-dt-color-fill-muted-pink': 'var(--st-dt-color-pink-90)',
    '--st-dt-color-fill-muted-purple': 'var(--st-dt-color-purple-90)',
    '--st-dt-color-text-primary': 'var(--st-dt-color-neutral-05)',
    '--st-dt-color-text-secondary': 'var(--st-dt-color-neutral-20)',
    '--st-dt-color-text-primary-inverted': 'var(--st-dt-color-neutral-90)',
    '--st-dt-color-text-secondary-inverted': 'var(--st-dt-color-neutral-70)',
    '--st-dt-color-text-disabled': 'var(--st-dt-color-neutral-50)',
    '--st-dt-color-text-accent': 'var(--st-dt-color-blue-30)',
    '--st-dt-color-icon-primary-default': 'var(--st-dt-color-neutral-05)',
    '--st-dt-color-icon-secondary': 'var(--st-dt-color-neutral-40)',
    '--st-dt-color-icon-primary-inverted-default': 'var(--st-dt-color-neutral-90)',
    '--st-dt-color-icon-secondary-inverted': 'var(--st-dt-color-neutral-70)',
    '--st-dt-color-icon-interactive-default': 'var(--st-dt-color-blue-20)',
    '--st-dt-color-icon-interactive-hover': 'var(--st-dt-color-blue-30)',
    '--st-dt-color-icon-interactive-pressed': 'var(--st-dt-color-blue-10)',
    '--st-dt-color-icon-interactive-disabled': 'var(--st-dt-color-blue-80)',
    '--st-dt-color-icon-critical-default': 'var(--st-dt-color-red-20)',
    '--st-dt-color-icon-critical-hover': 'var(--st-dt-color-red-30)',
    '--st-dt-color-icon-critical-pressed': 'var(--st-dt-color-red-10)',
    '--st-dt-color-icon-critical-disabled': 'var(--st-dt-color-red-80)',
    '--st-dt-color-icon-primary-hover': 'var(--st-dt-color-neutral-10)',
    '--st-dt-color-icon-primary-pressed': 'var(--st-dt-color-neutral-00)',
    '--st-dt-color-icon-primary-disabled': 'var(--st-dt-color-neutral-40)',
    '--st-dt-color-icon-primary-inverted-hover': 'var(--st-dt-color-neutral-80)',
    '--st-dt-color-icon-primary-inverted-pressed': 'var(--st-dt-color-neutral-100)',
    '--st-dt-color-icon-primary-inverted-disabled': 'var(--st-dt-color-neutral-60)',
    '--st-dt-color-link-primary-default': 'var(--st-dt-color-blue-20)',
    '--st-dt-color-link-primary-hover': 'var(--st-dt-color-blue-30)',
    '--st-dt-color-link-primary-pressed': 'var(--st-dt-color-blue-10)',
    '--st-dt-color-link-primary-disabled': 'var(--st-dt-color-blue-80)',
    '--st-dt-color-link-inverted-default': 'var(--st-dt-color-neutral-90)',
    '--st-dt-color-link-inverted-hover': 'var(--st-dt-color-neutral-80)',
    '--st-dt-color-link-inverted-pressed': 'var(--st-dt-color-neutral-100)',
    '--st-dt-color-link-inverted-disabled': 'var(--st-dt-color-neutral-60)',
    '--st-dt-color-link-neutral-default': 'var(--st-dt-color-neutral-05)',
    '--st-dt-color-link-neutral-hover': 'var(--st-dt-color-neutral-10)',
    '--st-dt-color-link-neutral-pressed': 'var(--st-dt-color-neutral-00)',
    '--st-dt-color-link-neutral-disabled': 'var(--st-dt-color-neutral-40)',
    '--st-dt-color-link-critical-default': 'var(--st-dt-color-red-20)',
    '--st-dt-color-link-critical-hover': 'var(--st-dt-color-red-30)',
    '--st-dt-color-link-critical-pressed': 'var(--st-dt-color-red-10)',
    '--st-dt-color-link-critical-disabled': 'var(--st-dt-color-red-80)',
    '--st-dt-color-border-primary': 'var(--st-dt-color-neutral-70)',
    '--st-dt-color-border-border-focus': 'var(--st-dt-color-blue-20)',
    '--st-dt-color-action-primary-bg-default': 'var(--st-dt-color-blue-20)',
    '--st-dt-color-action-primary-bg-hover': 'var(--st-dt-color-blue-30)',
    '--st-dt-color-action-primary-bg-pressed': 'var(--st-dt-color-blue-10)',
    '--st-dt-color-action-primary-bg-disabled': 'var(--st-dt-color-transparent-blue20-alpha30)',
    '--st-dt-color-action-primary-critical-bg-default': 'var(--st-dt-color-red-20)',
    '--st-dt-color-action-primary-critical-bg-hover': 'var(--st-dt-color-red-30)',
    '--st-dt-color-action-primary-critical-bg-pressed': 'var(--st-dt-color-red-10)',
    '--st-dt-color-action-primary-critical-bg-disabled': 'var(--st-dt-color-transparent-red20-alpha30)',
    '--st-dt-color-action-secondary-bg-default': 'var(--st-dt-color-neutral-100)',
    '--st-dt-color-action-secondary-bg-hover': 'var(--st-dt-color-blue-80)',
    '--st-dt-color-action-secondary-bg-pressed': 'var(--st-dt-color-blue-70)',
    '--st-dt-color-action-secondary-bg-disabled': 'var(--st-dt-color-neutral-90)',
    '--st-dt-color-action-secondary-border-default': 'var(--st-dt-color-blue-20)',
    '--st-dt-color-action-secondary-border-hover': 'var(--st-dt-color-blue-30)',
    '--st-dt-color-action-secondary-border-pressed': 'var(--st-dt-color-blue-10)',
    '--st-dt-color-action-secondary-border-disabled': 'var(--st-dt-color-blue-80)',
    '--st-dt-color-action-secondary-critical-bg-default': 'var(--st-dt-color-neutral-100)',
    '--st-dt-color-action-secondary-critical-bg-hover': 'var(--st-dt-color-red-80)',
    '--st-dt-color-action-secondary-critical-bg-pressed': 'var(--st-dt-color-red-70)',
    '--st-dt-color-action-secondary-critical-bg-disabled': 'var(--st-dt-color-neutral-90)',
    '--st-dt-color-action-tertiary-bg-hover': 'var(--st-dt-color-blue-80)',
    '--st-dt-color-action-tertiary-bg-pressed': 'var(--st-dt-color-blue-70)',
    '--st-dt-color-action-tertiary-critical-bg-hover': 'var(--st-dt-color-red-80)',
    '--st-dt-color-action-tertiary-critical-bg-pressed': 'var(--st-dt-color-red-70)',
    '--st-dt-color-action-utility-bg-default': 'var(--st-dt-color-neutral-100)',
    '--st-dt-color-action-utility-bg-hover': 'var(--st-dt-color-neutral-80)',
    '--st-dt-color-action-utility-bg-pressed': 'var(--st-dt-color-neutral-70)',
    '--st-dt-color-action-utility-selected-bg-default': 'var(--st-dt-color-neutral-05)',
    '--st-dt-color-action-utility-selected-bg-hover': 'var(--st-dt-color-neutral-10)',
    '--st-dt-color-action-utility-selected-bg-pressed': 'var(--st-dt-color-neutral-00)',
    '--st-dt-color-action-utility-selected-bg-disabled': 'var(--st-dt-color-neutral-50)',
    '--st-dt-color-action-utility-border': 'var(--st-dt-color-neutral-40)',
    '--st-dt-color-action-utility-bg-disabled': 'var(--st-dt-color-neutral-90)',
    '--st-dt-color-action-utility-selected-border': 'var(--st-dt-color-neutral-05)',
    '--st-dt-color-action-utility-adaptive-bg-hover': 'var(--st-dt-color-transparent-neutral05-alpha10)',
    '--st-dt-color-action-utility-adaptive-bg-pressed': 'var(--st-dt-color-transparent-neutral05-alpha20)',
    '--st-dt-color-input-bg-default': 'var(--st-dt-color-neutral-100)',
    '--st-dt-color-input-border-default': 'var(--st-dt-color-neutral-50)',
    '--st-dt-color-input-border-hover': 'var(--st-dt-color-blue-30)',
    '--st-dt-color-input-border-pressed': 'var(--st-dt-color-blue-10)',
    '--st-dt-color-input-border-disabled': 'var(--st-dt-color-neutral-80)',
    '--st-dt-color-input-bg-disabled': 'var(--st-dt-color-neutral-90)',
    '--st-dt-color-input-selected-bg-default': 'var(--st-dt-color-blue-20)',
    '--st-dt-color-input-selected-bg-hover': 'var(--st-dt-color-blue-30)',
    '--st-dt-color-input-selected-bg-pressed': 'var(--st-dt-color-blue-10)',
    '--st-dt-color-input-selected-bg-disabled': 'var(--st-dt-color-blue-80)',
    '--st-dt-color-input-selected-critical-bg-default': 'var(--st-dt-color-red-20)',
    '--st-dt-color-input-selected-critical-bg-hover': 'var(--st-dt-color-red-30)',
    '--st-dt-color-input-selected-critical-bg-pressed': 'var(--st-dt-color-red-10)',
    '--st-dt-color-input-selected-critical-bg-disabled': 'var(--st-dt-color-red-80)',
    '--st-dt-color-input-selected-border-default': 'var(--st-dt-color-blue-20)',
    '--st-dt-color-input-selected-border-disabled': 'var(--st-dt-color-blue-60)',
    '--st-dt-color-status-info-bg': 'var(--st-dt-color-blue-80)',
    '--st-dt-color-status-info-border': 'var(--st-dt-color-blue-20)',
    '--st-dt-color-status-info-icon': 'var(--st-dt-color-blue-20)',
    '--st-dt-color-status-success-bg': 'var(--st-dt-color-green-80)',
    '--st-dt-color-status-success-border-default': 'var(--st-dt-color-green-20)',
    '--st-dt-color-status-success-icon': 'var(--st-dt-color-green-20)',
    '--st-dt-color-status-warning-bg': 'var(--st-dt-color-yellow-80)',
    '--st-dt-color-status-warning-border-default': 'var(--st-dt-color-yellow-20)',
    '--st-dt-color-status-warning-icon': 'var(--st-dt-color-yellow-20)',
    '--st-dt-color-status-critical-bg': 'var(--st-dt-color-red-80)',
    '--st-dt-color-status-critical-border-default': 'var(--st-dt-color-red-20)',
    '--st-dt-color-status-critical-icon': 'var(--st-dt-color-red-20)',
    '--st-dt-color-status-bias-bg': 'var(--st-dt-color-pink-80)',
    '--st-dt-color-status-bias-border': 'var(--st-dt-color-pink-20)',
    '--st-dt-color-status-bias-icon': 'var(--st-dt-color-pink-20)',
    '--st-dt-color-status-info-fill': 'var(--st-dt-color-blue-40)',
    '--st-dt-color-status-success-fill': 'var(--st-dt-color-green-40)',
    '--st-dt-color-status-warning-fill': 'var(--st-dt-color-yellow-50)',
    '--st-dt-color-status-critical-fill': 'var(--st-dt-color-red-40)',
    '--st-dt-color-status-bias-fill': 'var(--st-dt-color-pink-40)',
    '--st-dt-color-status-neutral-fill': 'var(--st-dt-color-neutral-40)',
    '--st-dt-color-status-neutral-border': 'var(--st-dt-color-neutral-20)',
    '--st-dt-color-status-success-border-hover': 'var(--st-dt-color-green-30)',
    '--st-dt-color-status-success-border-pressed': 'var(--st-dt-color-green-10)',
    '--st-dt-color-status-warning-border-hover': 'var(--st-dt-color-yellow-30)',
    '--st-dt-color-status-warning-border-pressed': 'var(--st-dt-color-yellow-10)',
    '--st-dt-color-status-critical-border-hover': 'var(--st-dt-color-red-30)',
    '--st-dt-color-status-critical-border-pressed': 'var(--st-dt-color-red-10)',
    '--st-dt-color-status-critical-border-disabled': 'var(--st-dt-color-red-80)',
    '--st-dt-color-status-info-border-disabled': 'var(--st-dt-color-blue-70)',
    '--st-dt-color-tenure-gold': '#85714d',
    '--st-dt-color-tenure-blue': '#379aec',
    '--st-dt-color-tenure-yellow': '#f4980a',
    '--st-dt-color-tenure-red': '#da3733',
    '--st-dt-color-tenure-purple': '#a249e0',
    '--st-dt-color-tenure-silver': '#737e8b',
    '--st-dt-color-transparent-neutral90-alpha30': '#232f3e4d',
    '--st-dt-color-transparent-neutral90-alpha10': '#232f3e1a',
    '--st-dt-color-transparent-neutral90-alpha20': '#232f3e33',
    '--st-dt-color-transparent-neutral100-alpha70': '#161e2db3',
    '--st-dt-color-transparent-alpha0': '#00000000',
    '--st-dt-color-transparent-black-alpha70': '#000000b3',
    '--st-dt-color-transparent-blue70-alpha30': '#1768c94d',
    '--st-dt-color-transparent-blue60-alpha70': '#0077d9b3',
    '--st-dt-color-transparent-blue20-alpha30': '#afd7f74d',
    '--st-dt-color-transparent-red20-alpha30': '#fbc3bf4d',
    '--st-dt-color-transparent-red70-alpha30': '#bb29294d',
    '--st-dt-color-transparent-neutral05-alpha10': '#f1f4f71a',
    '--st-dt-color-transparent-neutral05-alpha20': '#f1f4f733',
    '--st-dt-color-transparent-orange40-alpha30': '#ff84004d',
    '--st-dt-color-transparent-orange50-alpha30': '#ff62004d',
    '--st-dt-color-gradient-elevation': 'var(--st-dt-color-transparent-black-alpha70)',
    '--st-dt-color-cream-10': '#f5efe2',
    '--st-dt-color-cream-20': '#eae2d0',
    '--st-dt-color-cream-30': '#d2c6b0',
    '--st-dt-color-cream-40': '#b4a890',
    '--st-dt-color-cream-50': '#9e917a',
    '--st-dt-color-cream-60': '#90846d',
    '--st-dt-color-cream-70': '#847761',
    '--st-dt-color-cream-80': '#6a5e48',
    '--st-dt-color-cream-90': '#3a2f1b',
    '--st-dt-color-cream-100': '#2d1f00',
    '--st-dt-color-cream-05': '#f5f3ef',
    '--st-dt-color-magenta-10': '#fbe8ff',
    '--st-dt-color-magenta-20': '#f5d6ff',
    '--st-dt-color-magenta-30': '#e6aeff',
    '--st-dt-color-magenta-40': '#d67cff',
    '--st-dt-color-magenta-50': '#c568f2',
    '--st-dt-color-magenta-60': '#b25dea',
    '--st-dt-color-magenta-70': '#a24dd9',
    '--st-dt-color-magenta-80': '#8a3abe',
    '--st-dt-color-magenta-90': '#54007b',
    '--st-dt-color-magenta-05': '#fdf2ff',
    '--st-dt-color-teal-10': '#dffcf9',
    '--st-dt-color-teal-20': '#b1ece7',
    '--st-dt-color-teal-30': '#6fd4cd',
    '--st-dt-color-teal-40': '#00beb7',
    '--st-dt-color-teal-50': '#00a29c',
    '--st-dt-color-teal-60': '#00928a',
    '--st-dt-color-teal-70': '#00857d',
    '--st-dt-color-teal-80': '#006964',
    '--st-dt-color-teal-90': '#003734',
    '--st-dt-color-teal-05': '#f4ffff',
    '--st-dt-color-orange-10': '#fff0cf',
    '--st-dt-color-orange-20': '#ffe4ad',
    '--st-dt-color-orange-30': '#ffb14a',
    '--st-dt-color-orange-40': '#ff8400',
    '--st-dt-color-orange-50': '#ff6200',
    '--st-dt-color-orange-55': '#f55600',
    '--st-dt-color-orange-60': '#e54f00',
    '--st-dt-color-orange-70': '#d14900',
    '--st-dt-color-orange-80': '#9d3011',
    '--st-dt-color-orange-90': '#63170f',
    '--st-dt-color-orange-05': '#fff7e3',
    '--st-dt-color-lavender-10': '#ecedff',
    '--st-dt-color-lavender-20': '#dcdeff',
    '--st-dt-color-lavender-30': '#bdc1ff',
    '--st-dt-color-lavender-40': '#9c9cff',
    '--st-dt-color-lavender-50': '#8680fb',
    '--st-dt-color-lavender-60': '#8680fb',
    '--st-dt-color-lavender-70': '#7368cd',
    '--st-dt-color-lavender-80': '#5b53a0',
    '--st-dt-color-lavender-90': '#302c56',
    '--st-dt-color-lavender-05': '#f5f5ff',
    '--st-dt-color-pictogram-primary': 'var(--st-dt-color-neutral-05)',
    '--st-dt-color-pictogram-accent': 'var(--st-dt-color-blue-40)',
    '--st-dt-color-pictogram-bg': 'var(--st-dt-color-neutral-90)',
    '--st-dt-dimensions-border-radius-50': '2px',
    '--st-dt-dimensions-border-radius-100': '4px',
    '--st-dt-dimensions-border-radius-200': '8px',
    '--st-dt-dimensions-border-radius-300': '12px',
    '--st-dt-dimensions-border-radius-400': '16px',
    '--st-dt-dimensions-border-radius-none': '0px',
    '--st-dt-dimensions-border-radius-round': '100px',
    '--st-dt-dimensions-border-width-100': '1px',
    '--st-dt-dimensions-border-width-200': '2px',
    '--st-dt-dimensions-border-width-300': '3px',
    '--st-dt-dimensions-border-width-400': '4px',
    '--st-dt-dimensions-border-width-500': '8px',
    '--st-dt-dimensions-border-width-none': '0px',
    '--st-dt-dimensions-z-index-100': 100,
    '--st-dt-dimensions-z-index-200': 200,
    '--st-dt-dimensions-z-index-300': 300,
    '--st-dt-dimensions-z-index-400': 400,
    '--st-dt-dimensions-z-index-500': 500,
    '--st-dt-dimensions-z-index-600': 600,
    '--st-dt-dimensions-z-index-700': 700,
    '--st-dt-dimensions-z-index-800': 800,
    '--st-dt-dimensions-z-index-900': 900,
    '--st-dt-dimensions-z-index-1000': 1000,
    '--st-dt-dimensions-spacing-50': '2px',
    '--st-dt-dimensions-spacing-100': '4px',
    '--st-dt-dimensions-spacing-200': '8px',
    '--st-dt-dimensions-spacing-250': '12px',
    '--st-dt-dimensions-spacing-300': '16px',
    '--st-dt-dimensions-spacing-400': '24px',
    '--st-dt-dimensions-spacing-500': '32px',
    '--st-dt-dimensions-spacing-600': '48px',
    '--st-dt-dimensions-spacing-700': '64px',
    '--st-dt-dimensions-spacing-800': '80px',
    '--st-dt-dimensions-spacing-none': '0px',
    '--st-dt-shadow-100': 'rgba(35, 47, 62, 0.3) 0px 0px 10px 0px ',
    '--st-dt-shadow-200': 'rgba(35, 47, 62, 0.3) 0px 0px 20px 0px ',
    '--st-dt-shadow-300': 'rgba(0, 0, 0, 0.7) 0px 0px 10px 0px ',
    '--st-dt-shadow-400': 'rgba(0, 0, 0, 0.7) 0px 0px 20px 0px ',
    '--st-dt-shadow-raised-rest': 'var(--st-dt-shadow-300)',
    '--st-dt-shadow-raised-hover': 'var(--st-dt-shadow-400)',
    '--st-dt-shadow-raised-pressed': 'var(--st-dt-shadow-300)',
    '--st-dt-shadow-none': '0px 0px 0px 0px '
  }
};
var _default = exports.default = designTokenVariables;